export default {
  首页: "Αρχική σελίδα",
  资产: "Περιουσιακά στοιχεία",
  币币: "Spot",
  快捷买币: "Γρήγορη αγορά κρυπτονομισμάτων",
  "支持多种方式购买，购买更简单":
    "Αγοράστε εύκολα με πολλαπλούς τρόπους πληρωμής",
  语言设置: "Ρυθμίσεις γλώσσας",
  确认恢复: "Επιβεβαίωση ανάκτησης",
  "输入邮箱，方便我们联系您":
    "Εισάγετε το email σας για να επικοινωνήσουμε μαζί σας",
  划转: "Μεταφορά",
  行情: "Αγορά",
  "24H成交": "Όγκος 24h",
  累计收益: "Συνολική απόδοση",
  充值时间: "Ημερομηνία κατάθεσης",
  到期时间: "Ημερομηνία λήξης",
  数量: "Ποσότητα",
  操作: "Ενέργεια",
  资产信息: "Πληροφορίες περιουσιακών στοιχείων",
  复制地址: "Αντιγραφή διεύθυνσης",
  链名称: "Όνομα blockchain",
  充值地址: "Διεύθυνση κατάθεσης",
  收款地址: "Διεύθυνση παραλαβής",
  账单: "Τιμολόγιο",
  提现金额: "Ποσό ανάληψης",
  接收地址: "Διεύθυνση παραλαβής",
  交易密码: "Κωδικός συναλλαγών",
  提现全部: "Ανάληψη όλων",
  保存图片: "Αποθήκευση εικόνας",
  输入您的交易密码: "Εισάγετε τον κωδικό συναλλαγών σας",
  确定: "Επιβεβαίωση",
  地址: "Διεύθυνση",
  注册时间: "Ημερομηνία εγγραφής",
  取消: "Ακύρωση",
  是否划转: "Μεταφορά;",
  登录: "Σύνδεση",
  我的地址: "Οι διευθύνσεις μου",
  登录密码和交易密码: "Κωδικός σύνδεσης και κωδικός συναλλαγών",
  注册: "Εγγραφή",
  密码: "Κωδικός πρόσβασης",
  设置密码: "Ορισμός κωδικού",
  重复密码: "Επανάληψη κωδικού",
  新密码: "Νέος κωδικός",
  确认新密码: "Επιβεβαίωση νέου κωδικού",
  充值: "Κατάθεση",
  充值货币: "Κατάθεση νομίσματος",
  合约账户充值: "Κατάθεση σε λογαριασμό συμβολαίων μελλοντικής εκπλήρωσης",
  账户充值: "Κατάθεση σε λογαριασμό",
  其他: "Άλλο",
  我的邀请码: "Ο κωδικός πρόσκλησής μου",
  提现: "Ανάληψη",
  客服: "Εξυπηρέτηση πελατών",
  持有详情: "Λεπτομέρειες κατοχής",
  请输入内容: "Εισάγετε περιεχόμενο",
  邀请好友来领取奖励: "Καλέστε φίλους και λάβετε ανταμοιβές",
  复制链接: "Αντιγραφή συνδέσμου",
  重复设置新的密码: "Επανάληψη νέου κωδικού",
  保存: "Αποθήκευση",
  我的: "Ο λογαριασμός μου",
  "邮箱/手机号": "Email/Αριθμός κινητού",
  备注: "Σχόλιο",
  地址管理: "Διαχείριση διευθύνσεων",
  我的团队: "Η ομάδα μου",
  联系我们: "Επικοινωνήστε μαζί μας",
  竭诚为您服务: "Είμαστε στη διάθεσή σας",
  提取收益: "Απόσυρση απόδοσης",
  带给我的收益: "Απόδοση που δημιουργήθηκε",
  添加: "Προσθήκη",
  名称: "Όνομα",
  添加地址: "Προσθήκη διεύθυνσης",
  修改地址: "Τροποποίηση διεύθυνσης",
  可提现: "Δυνατότητα ανάληψης",
  安全中心: "Κέντρο ασφαλείας",
  收益划转: "Μεταφορά απόδοσης",
  通知中心: "Ειδοποιήσεις",
  "累计收益:": "Συνολική απόδοση:",
  注册用户: "Εγγεγραμμένοι χρήστες",
  奖励规则: "Κανόνες ανταμοιβών",
  帮助反馈: "Βοήθεια & Σχόλια",
  邀请好友: "Πρόσκληση φίλων",
  恢复身份: "Ανάκτηση ταυτότητας",
  选择语言: "Επιλογή γλώσσας",
  设置新的密码: "Ορισμός νέου κωδικού",
  暂无活动: "Δεν υπάρχουν ενεργές δραστηριότητες",
  "月增长量(+)": "Μηνιαία αύξηση (+)",
  可提取: "Δυνατότητα απόσυρσης",
  反馈类型: "Τύπος σχολίου",
  赠送: "Δώρο",
  已经复制: "Αντιγράφηκε",
  保存成功: "Επιτυχής αποθήκευση",
  划转成功: "Επιτυχής μεταφορά",
  过期: "Έληξε",
  提交成功: "Επιτυχής υποβολή",
  "服务器繁忙，稍后在试":
    "Ο διακομιστής είναι απασχολημένος, δοκιμάστε ξανά αργότερα",
  全部: "Όλα",
  一级: "Επίπεδο 1",
  二级: "Επίπεδο 2",
  三级: "Επίπεδο 3",
  级: "Επίπεδο",
  删除成功: "Επιτυχής διαγραφή",
  选择地址: "Επιλογή διεύθυνσης",
  不再提醒: "Να μην εμφανίζεται ξανά",
  "最小充值金额：": "Ελάχιστο ποσό κατάθεσης:",
  选择币种: "Επιλογή κρυπτονομίσματος",
  输入投资金额: "Εισάγετε το ποσό επένδυσης",
  输入账户密码: "Εισάγετε τον κωδικό λογαριασμού",
  投资: "Επένδυση",
  订单编号: "Αριθμός παραγγελίας",
  投资周期: "Περίοδος επένδυσης",
  投资资金: "Επενδυμένο ποσό",
  投资时间: "Χρόνος επένδυσης",
  状态: "Κατάσταση",
  投资中: "Ενεργό",
  已到期: "Έληξε",
  暂无数据: "Δεν υπάρχουν δεδομένα",
  转入: "Μεταφορά σε",
  邮箱: "Email",
  请输入邮箱: "Εισάγετε email",
  请输入格式正确的邮箱: "Εισάγετε έγκυρο email",
  请输入验证码: "Εισάγετε τον κωδικό επαλήθευσης",
  获取验证码: "Λήψη κωδικού επαλήθευσης",
  请输入邀请码: "Εισάγετε τον κωδικό πρόσκλησης",
  今天: "Σήμερα",
  昨天: "Χθες",
  最近七天: "Τελευταίες 7 ημέρες",
  邀请: "Πρόσκληση",
  购买数量: "Ποσότητα αγοράς",
  产品详情: "Λεπτομέρειες προϊόντος",
  币种: "Κρυπτονόμισμα",
  利息币种: "Νόμισμα απόδοσης",
  理财类型: "Τύπος χρηματοοικονομικού προϊόντος",
  产品费率: "Χρεώσεις προϊόντος",
  进行中: "Ενεργό",
  每天: "Καθημερινά",
  请输入搜索关键词: "Εισάγετε λέξη-κλειδί αναζήτησης",
  通知: "Ειδοποιήσεις",
  查看更多: "Δείτε περισσότερα",
  理财宝: "Χρηματοοικονομικά προϊόντα",
  周期: "Διάρκεια",
  年利率: "Ετήσιο επιτόκιο (APY)",
  更多产品: "Περισσότερα προϊόντα",
  灵活存取: "Ευέλικτη αποταμίευση",
  稳定收益: "Σταθερή απόδοση",
  合约指南: "Οδηγός συμβολαίων μελλοντικής εκπλήρωσης",
  资金划转出: "Εξερχόμενη μεταφορά",
  矿池收益: "Ανταμοιβή εξόρυξης",
  提现手续费: "Χρέωση ανάληψης",
  冻结资金: "Παγωμένα κεφάλαια",
  解冻资金: "Αποδέσμευση παγωμένων κεφαλαίων",
  闪兑支出: "Δαπάνη ταχείας ανταλλαγής",
  闪兑收入: "Έσοδο ταχείας ανταλλαγής",
  闪兑手续费: "Χρέωση ταχείας ανταλλαγής",
  合约支出: "Δαπάνη συμβολαίων μελλοντικής εκπλήρωσης",
  合约收入: "Έσοδο συμβολαίων μελλοντικής εκπλήρωσης",
  输入的金额不可大于可用金额:
    "Το ποσό δεν μπορεί να υπερβαίνει το διαθέσιμο ποσό",
  全部兑换成功: "Επιτυχής ολική ανταλλαγή",
  返回: "Επιστροφή",
  查看历史: "Προβολή ιστορικού",
  闪兑历史: "Ιστορικό ταχείας ανταλλαγής",
  支付: "Πληρωμή",
  获取: "Λήψη",
  时间: "Χρόνος",
  手续费: "Χρέωση συναλλαγής",
  折扣: "Έκπτωση",
  价格: "Τιμή",
  逐仓: "Απομονωμένο περιθώριο",
  全仓: "Διασταυρούμενο περιθώριο",
  市价委托: "Εντολή αγοράς",
  限价委托: "Εντολή ορίου",
  请输入本金: "Εισάγετε το αρχικό κεφάλαιο",
  请输入价格: "Εισάγετε την τιμή",
  "可做空/做多": "Δυνατότητα ανοίγματος θέσης Short/Long",
  设置止盈止损: "Ορισμός ορίου κέρδους/διακοπής ζημίας",
  止盈价: "Τιμή ορίου κέρδους",
  止损价: "Τιμή διακοπής ζημίας",
  成本: "Τιμή κόστους",
  做多: "Long (Αγορά)",
  做空: "Short (Πώληση)",
  仓位信息: "Πληροφορίες θέσης",
  一键平仓: "Κλείσιμο θέσης (ένα κλικ)",
  永续: "Διαιωνιζόμενο",
  浮动盈亏: "Μη πραγματοποιηθέν κέρδος/ζημία",
  平仓: "Κλείσιμο θέσης",
  反向开仓: "Αντίστροφο άνοιγμα θέσης",
  一键撤销: "Ακύρωση όλων (ένα κλικ)",
  倍杠杆: "x μόχλευση",
  执行价格: "Τιμή εκτέλεσης",
  委托数量: "Ποσότητα εντολής",
  保证金: "Περιθώριο",
  成交价: "Τιμή εκτέλεσης",
  创建时间: "Ώρα δημιουργίας",
  撤销: "Ακύρωση",
  合约市场: "Αγορά συμβολαίων μελλοντικής εκπλήρωσης",
  交易方向: "Κατεύθυνση συναλλαγής",
  委托价格: "Τιμή εντολής",
  委托金额: "Ποσό εντολής",
  资金费率: "Επιτόκιο χρηματοδότησης",
  "多方和空方交易者支付的定期费用，每8小时结算一次。":
    "Περιοδική χρέωση που καταβάλλεται από long και short θέσεις, διακανονίζεται κάθε 8 ώρες.",
  "资金费率为正，多方向空方支付资金费用。":
    "Με θετικό επιτόκιο χρηματοδότησης, οι long θέσεις πληρώνουν τις short θέσεις.",
  "资金费率为负，空方向多方支付资金费用。":
    "Με αρνητικό επιτόκιο χρηματοδότησης, οι short θέσεις πληρώνουν τις long θέσεις.",
  "确定反向开仓吗？反向开仓将以当期相反 的仓位进行买入":
    "Είστε σίγουροι ότι θέλετε να ανοίξετε αντίστροφη θέση; Αυτό θα αγοράσει την αντίθετη κατεύθυνση από την τρέχουσα θέση σας.",
  "仓位止盈/止损": "Όριο κέρδους/διακοπής ζημίας για θέση",
  合约名称: "Συμβόλαιο μελλοντικής εκπλήρωσης",
  开仓价格: "Τιμή ανοίγματος",
  指数价格: "Τιμή δείκτη",
  止盈设置: "Ρυθμίσεις ορίου κέρδους",
  请输入止盈价: "Εισάγετε τιμή ορίου κέρδους",
  "当指数价格触达*时，将会触发委托平仓":
    "Όταν η τιμή του δείκτη φτάσει το *, θα ενεργοποιηθεί εντολή κλεισίματος.",
  预计盈亏: "Αναμενόμενο κέρδος/ζημία",
  当前仓位: "Τρέχουσα θέση",
  平仓金额: "Ποσό κλεισίματος",
  仓位模式: "Λειτουργία θέσης",
  全仓模式: "Λειτουργία διασταυρούμενου περιθωρίου",
  "合约账户中的所有可用资金视作为可用保证金， 当仓位亏损超过了账户余额才会爆仓强平，并将损失所有 保证金和仓位，请注意":
    "Στη λειτουργία διασταυρούμενου περιθωρίου, όλα τα διαθέσιμα κεφάλαια στο λογαριασμό συμβολαίων μελλοντικής εκπλήρωσης χρησιμοποιούνται ως περιθώριο. Η ρευστοποίηση συμβαίνει όταν η ζημία υπερβεί το συνολικό υπόλοιπό σας, με αποτέλεσμα να χάσετε ολόκληρο το περιθώριο και τη θέση σας.",
  逐仓模式: "Λειτουργία απομονωμένου περιθωρίου",
  "会使合约账户中的一定数量保证金被分配到仓位上。如果保证金亏损低于维持保证金的水平，仓位被强平。在逐仓模式下，您可以为这个仓位增加和减少保证金。":
    "Ένα συγκεκριμένο ποσό περιθωρίου εκχωρείται σε μια θέση. Εάν η ζημία περιθωρίου πέσει κάτω από το επίπεδο περιθωρίου συντήρησης, η θέση ρευστοποιείται. Μπορείτε να αυξήσετε ή να μειώσετε το περιθώριο για αυτήν τη θέση.",
  "是否撤销？": "Ακύρωση εντολής;",
  "是否一键撤销？": "Ακύρωση όλων των εντολών;",
  "是否一键平仓？": "Κλείσιμο όλων των θέσεων;",
  持仓保证金: "Περιθώριο τρέχουσας θέσης",
  风险率: "Ποσοστό κινδύνου",
  未实现盈亏: "Μη πραγματοποιηθέν κέρδος/ζημία",
  可用保证金: "Διαθέσιμο περιθώριο",
  净值: "Καθαρή αξία",
  账户余额: "Υπόλοιπο λογαριασμού",
  合约计算器: "Υπολογιστής συμβολαίων μελλοντικής εκπλήρωσης",
  交易记录: "Ιστορικό συναλλαγών",
  "*倍杠杆": "*x μόχλευση",
  "平仓盈亏：": "Πραγματοποιηθέν κέρδος/ζημία:",
  时间筛选: "Φίλτρο χρόνου",
  仓位类型: "Τύπος θέσης",
  订单状态: "Κατάσταση παραγγελίας",
  订单类型: "Τύπος παραγγελίας",
  平仓价格: "Τιμή κλεισίματος",
  持仓数量: "Ποσότητα θέσης",
  "手续费(%)": "Χρέωση συναλλαγής (%)",
  平仓时间: "Ώρα κλεισίματος",
  平仓类型: "Τύπος κλεισίματος",
  手动平仓: "Μη αυτόματο κλείσιμο",
  强制平仓: "Αναγκαστική ρευστοποίηση",
  近1天: "Τελευταία ημέρα",
  近7天: "Τελευταίες 7 ημέρες",
  近30天: "Τελευταίες 30 ημέρες",
  近180天: "Τελευταίες 180 ημέρες",
  持仓: "Ανοιχτή θέση",
  已取消: "Ακυρώθηκε",
  分时: "Ενδοημερήσιο",
  "24H额(USDT)": "Όγκος 24h (USDT)",
  "24H低": "Χαμηλό 24h",
  "24H量(BTC)": "Όγκος 24h (BTC)",
  "24H高": "Υψηλό 24h",
  "10秒": "10 δευτερόλεπτα",
  "30秒": "30 δευτερόλεπτα",
  "1分": "1 λεπτό",
  "3分": "3 λεπτά",
  "5分": "5 λεπτά",
  "30分": "30 λεπτά",
  "1小时": "1 ώρα",
  "4小时": "4 ώρες",
  "8小时": "8 ώρες",
  "1天": "1 ημέρα",
  "1周": "1 εβδομάδα",
  "1月": "1 μήνας",
  单向持仓: "Θέση μονής κατεύθυνσης",
  杠杆: "Μόχλευση",
  仓位: "Θέση",
  计算结果: "Αποτέλεσμα",
  盈亏: "Κέρδος/Ζημία",
  收益率: "Απόδοση",
  计算结果仅供参考: "Το αποτέλεσμα είναι ενδεικτικό",
  成交后仓位大小: "Μέγεθος θέσης μετά την εκτέλεση",
  "计算结果仅供参考,实际结果可能因费率差异":
    "Το αποτέλεσμα είναι ενδεικτικό, τα πραγματικά αποτελέσματα ενδέχεται να διαφέρουν λόγω χρεώσεων.",
  目标价格: "Τιμή στόχος",
  开始计算: "Υπολογισμός",
  强平价格: "Τιμή ρευστοποίησης",
  "充值前，请认真核对充值的链名称，充值错误无法找回资产*最小充值金额为*；少于此金额平台将无法确认到账，请不要向此地址充值*之外的资产，否则将无法找回资产，请不要直接提现众筹或者ICO地址，平台不会代理币的发放。":
    "Ελέγξτε προσεκτικά το όνομα του blockchain πριν από την κατάθεση. Οι λανθασμένες καταθέσεις δεν μπορούν να ανακτηθούν. Το ελάχιστο ποσό κατάθεσης είναι *. Καταθέσεις κάτω από αυτό το ποσό δεν θα υποστούν επεξεργασία. Μην στέλνετε άλλα περιουσιακά στοιχεία σε αυτήν τη διεύθυνση. Μην χρησιμοποιείτε διευθύνσεις ICO ή crowdfunding για αναλήψεις.",
  "最小输入*": "Ελάχιστο {0}",
  "最小提币数量为*，提币手续费将从你的提款金额中扣除。提币前请确认核对收款地址，不要将*提现至*以外的地址，否则无法找回资产。请不要直接提现众筹或者ICO地址，平台不会处理代币的发放。":
    "Η ελάχιστη ποσότητα ανάληψης είναι *. Οι χρεώσεις ανάληψης θα αφαιρεθούν από το ποσό ανάληψης. Ελέγξτε προσεκτικά τη διεύθυνση του παραλήπτη. Μην στέλνετε * σε διευθύνσεις εκτός από *. Μην χρησιμοποιείτε διευθύνσεις ICO ή crowdfunding.",
  退出登录: "Αποσύνδεση",
  加仓: "Αύξηση θέσης",
  新增仓位: "Νέα θέση",
  输入加仓金额: "Εισάγετε ποσό για αύξηση θέσης",
  "当前可用:": "Τρέχον διαθέσιμο:",
  资产账单: "Τιμολόγιο περιουσιακών στοιχείων",
  保存二维码: "Αποθήκευση κωδικού QR",
  温馨提示: "Σημείωση",
  "请注意：您当前使用的网络":
    "Σημείωση: Χρησιμοποιείτε αυτήν τη στιγμή το δίκτυο",
  输入提现地址: "Εισάγετε διεύθυνση ανάληψης",
  "可用金额：": "Διαθέσιμο ποσό:",
  输入资产密码: "Εισάγετε τον κωδικό περιουσιακών στοιχείων",
  可用手续费: "Διαθέσιμη χρέωση",
  "折扣%": "Έκπτωση %",
  实扣手续费: "Πραγματική χρέωση",
  实际到账: "Πραγματικό ποσό παραλαβής",
  未设置资产密码: "Δεν έχει οριστεί κωδικός περιουσιακών στοιχείων",
  "为了您的资产安全，请设置资产密码后再来提现。":
    "Για την ασφάλειά σας, ορίστε έναν κωδικό περιουσιακών στοιχείων πριν κάνετε αναλήψεις.",
  热榜: "Δημοφιλή",
  涨幅榜: "Μεγαλύτερες αυξήσεις",
  跌幅榜: "Μεγαλύτερες μειώσεις",
  成交额榜: "Κατάταξη όγκου",
  关于我们: "Σχετικά με εμάς",
  登录密码: "Κωδικός σύνδεσης",
  设置: "Ρυθμίσεις",
  资产密码: "Κωδικός περιουσιακών στοιχείων",
  修改登录密码: "Αλλαγή κωδικού σύνδεσης",
  原密码: "Παλαιός κωδικός",
  请输入新密码: "Εισάγετε νέο κωδικό",
  请输入原密码: "Εισάγετε παλαιό κωδικό",
  确认密码: "Επιβεβαίωση κωδικού",
  确定修改: "Επιβεβαίωση αλλαγής",
  修改资产密码: "Αλλαγή κωδικού περιουσιακών στοιχείων",
  验证码: "Κωδικός επαλήθευσης",
  资产密码使用提示: "Συμβουλές για τον κωδικό περιουσιακών στοιχείων",
  "资产密码用于转移、提取资产和交易。":
    "Ο κωδικός περιουσιακών στοιχείων χρησιμοποιείται για τη μεταφορά, ανάληψη και διαπραγμάτευση περιουσιακών στοιχείων.",
  "创建与登录密码不同的资产密码。":
    "Δημιουργήστε έναν κωδικό περιουσιακών στοιχείων διαφορετικό από τον κωδικό σύνδεσης.",
  "定期更改您的资产密码。":
    "Αλλάζετε τακτικά τον κωδικό περιουσιακών στοιχείων σας.",
  提币历史: "Ιστορικό αναλήψεων",
  "金额/余额": "Ποσό/Υπόλοιπο",
  "手续费/折扣": "Χρέωση/Έκπτωση",
  自选: "Αγαπημένα",
  现货: "Spot",
  市价: "Τρέχουσα τιμή",
  止损设置: "Ρυθμίσεις διακοπής ζημίας",
  合约K线图: "Γράφημα συμβολαίων μελλοντικής εκπλήρωσης",
  "24H量": "Όγκος 24h",
  "24H额": "Όγκος 24h (USDT)",
  合作指南: "Οδηγός συνεργάτη",
  盈亏计算: "Υπολογισμός κέρδους/ζημίας",
  当前可用: "Τρέχον διαθέσιμο",
  请输入加仓金额: "Εισάγετε ποσό για αύξηση θέσης",
  请重新输入加仓金额: "Εισάγετε ξανά το ποσό για αύξηση θέσης",
  平仓数量: "Ποσότητα κλεισίματος",
  欢迎登录: "Καλώς ορίσατε πίσω",
  "忘记密码?": "Ξεχάσατε τον κωδικό;",
  "还没有账号？": "Δεν έχετε ακόμα λογαριασμό;",
  立即注册: "Εγγραφή τώρα",
  繁體中文: "Παραδοσιακά Κινέζικα",
  找回密码: "Ανάκτηση κωδικού",
  下一步: "Επόμενο",
  注册账户: "Εγγραφή λογαριασμού",
  "请输入邀请码(选填)": "Εισάγετε κωδικό πρόσκλησης (προαιρετικό)",
  谢邀豪礼: "Μπόνους πρόσκλησης",
  "24小时邀请好友排名": "Κατάταξη προσκλήσεων 24ωρου",
  "*人": "* άτομα",
  "差*人": "Χρειάζονται * άτομα ακόμα",
  "已超过10万人，每月轻松赚钱":
    "Πάνω από 100.000 χρήστες, κερδίστε χρήματα εύκολα κάθε μήνα",
  最高: "Μέγιστο",
  邀请链接: "Σύνδεσμος πρόσκλησης",
  "平台和您共享好友在平台（现货、合约、杠杆、闪兑）所产生的手续费":
    "Μοιραστείτε τις χρεώσεις συναλλαγών που δημιουργούνται από τους φίλους σας (spot, συμβόλαια μελλοντικής εκπλήρωσης, περιθώριο, ταχεία ανταλλαγή).",
  平台和您一起分享手续费:
    "Μοιραστείτε τις χρεώσεις συναλλαγών με την πλατφόρμα",
  "*级": "* επίπεδο",
  规则: "Κανόνες",
  我的好友: "Οι φίλοι μου",
  好友详情: "Λεπτομέρειες φίλου",
  获得好友佣金方案: "Πρόγραμμα προμήθειας φίλων",
  我的等级: "Το επίπεδό μου",
  我的邀请数据: "Τα στατιστικά πρόσκλησής μου",
  当前等级: "Τρέχον επίπεδο",
  平台奖励您: "Ανταμοιβή πλατφόρμας για εσάς",
  最高可获取平台奖励: "Μέγιστη ανταμοιβή πλατφόρμας",
  邀请规则: "Κανόνες πρόσκλησης",
  "邀请*级有效好友": "Καλέστε ενεργούς φίλους επιπέδου *",
  好友等级: "Επίπεδο φίλου",
  人: "άτομα",
  奖金派送: "Πληρωμή μπόνους",
  平台奖励: "Ανταμοιβή πλατφόρμας",
  "最终解释权归平台所有，若发现异常获取平台奖励，将会扣除所有的奖励，并且冻结账户，资产的损失将无法找回。":
    "Η πλατφόρμα διατηρεί το δικαίωμα τελικής ερμηνείας. Σε περίπτωση δόλιων δραστηριοτήτων, οι ανταμοιβές θα αφαιρεθούν και ο λογαριασμός σας θα παγώσει. Τα χαμένα περιουσιακά στοιχεία δεν μπορούν να ανακτηθούν.",
  "您的账户必须是有效账户，平台判定有效账户条件为（账户充值任何币种）最小* USDT的价值。":
    "Ο λογαριασμός σας πρέπει να είναι ενεργός, ο οποίος ορίζεται ως κατάθεση αξίας τουλάχιστον * USDT σε οποιοδήποτε κρυπτονόμισμα.",
  "您邀请的好友，必须是有效下级，平台判定有效下级为（账户充值任何币种）最小* USDT的价值。":
    "Ο φίλος που καλέσατε πρέπει να είναι ενεργός downline, ο οποίος ορίζεται ως κατάθεση αξίας τουλάχιστον * USDT.",
  "邀请人和被邀请者的账号不能同属于一个IP。":
    "Ο καλών και ο προσκεκλημένος δεν μπορούν να μοιράζονται την ίδια διεύθυνση IP.",
  "VIP等级由您邀请的*级好友的人数作为考核。":
    "Το επίπεδο VIP καθορίζεται από τον αριθμό των φίλων επιπέδου * που έχετε καλέσει.",
  佣金成分: "Συστατικά προμήθειας",
  收益统计: "Στατιστικά απόδοσης",
  昨日收益: "Απόδοση χθες",
  月收益: "Μηνιαία απόδοση",
  获取收益: "Λήψη απόδοσης",
  "总收益：": "Συνολική απόδοση:",
  "*级好友": "Φίλοι επιπέδου *",
  理财购买: "Αγορά χρηματοοικονομικού προϊόντος",
  期限: "Διάρκεια",
  可用金额: "Διαθέσιμο ποσό",
  预估收益: "Εκτιμώμενη απόδοση",
  申购上限: "Μέγιστη αγορά",
  项目剩余: "Υπόλοιπο έργου",
  "买入后预计*(SGT)开始计算收益。":
    "Η απόδοση θα αρχίσει να υπολογίζεται περίπου στις *(SGT) μετά την αγορά.",
  计息日: "Έναρξη υπολογισμού τόκων",
  申购日: "Ημερομηνία αγοράς",
  到账日: "Ημερομηνία πίστωσης",
  到期自动续投: "Αυτόματη επανεπένδυση κατά τη λήξη",
  申购: "Αγορά",
  搜索理财项目: "Αναζήτηση χρηματοοικονομικού προϊόντος",
  超高年化随心选: "Επιλέξτε ανάμεσα σε προϊόντα υψηλής απόδοσης",
  "自由选择理财币种，稳定超额收益":
    "Επιλέξτε ελεύθερα το κρυπτονόμισμά σας για σταθερές, υπεραποδόσεις",
  理财总资产: "Σύνολο επενδεδυμένων περιουσιακών στοιχείων",
  申购数量: "Ποσότητα προς αγορά",
  立即购买: "Άμεση αγορά",
  年化收益率: "Ετήσια ποσοστιαία απόδοση (APY)",
  理财订单: "Παραγγελίες χρηματοοικονομικών προϊόντων",
  持有: "Κατοχή",
  申购份额: "Αγορασθέν μερίδιο",
  到账日期: "Ημερομηνία πίστωσης",
  申购成功: "Επιτυχής αγορά",
  到期: "Έληξε",
  是否选择做多: "Να ανοίξετε θέση Long;",
  "可用余额为0 不能操作": "Το υπόλοιπο είναι 0, η ενέργεια δεν είναι δυνατή",
  福利中心: "Κέντρο μπόνους",
  奖励记录: "Ιστορικό ανταμοιβών",
  我获取到的奖励: "Οι ανταμοιβές που έχω κερδίσει",
  总价值: "Συνολική αξία",
  新手任务: "Εργασίες για νέους χρήστες",
  身份认证: "Επαλήθευση ταυτότητας (KYC)",
  身份验证: "Επαλήθευση ταυτότητας",
  去验证: "Επαλήθευση τώρα",
  审核中: "Σε αναμονή",
  已验证: "Επαληθεύτηκε",
  认证失败: "Η επαλήθευση απέτυχε",
  基础认证: "Βασική επαλήθευση",
  "请注意认证信息一经验证不能修改，务必填写准确信息":
    "Σημείωση: Οι επαληθευμένες πληροφορίες δεν μπορούν να αλλάξουν. Εισάγετε σωστά δεδομένα.",
  "国家/地区": "Χώρα/Περιοχή",
  请选择: "Επιλογή",
  证件类型: "Τύπος εγγράφου",
  证件编码: "Αριθμός εγγράφου",
  身份证: "Δελτίο ταυτότητας",
  护照: "Διαβατήριο",
  驾驶证: "Άδεια οδήγησης",
  请输入编码: "Εισάγετε αριθμό",
  名字: "Όνομα",
  请输入: "Εισάγετε",
  中间名: "Μεσαίο όνομα",
  选填: "Προαιρετικό",
  姓氏: "Επώνυμο",
  中国: "Κίνα",
  身份上传: "Μεταφόρτωση εγγράφου ταυτότητας",
  上传身份证: "Μεταφόρτωση δελτίου ταυτότητας",
  "以上材料需要用JPG/JPEG/PNG格式上传，并且保证照片的清晰边角完整，亮度均匀。且大小不超过*M。":
    "Μεταφορτώστε σε μορφή JPG/JPEG/PNG. Βεβαιωθείτε ότι οι εικόνες είναι καθαρές, πλήρεις και με ομοιόμορφο φωτισμό. Μέγιστο *MB.",
  确定提交: "Υποβολή",
  去认证: "Επαλήθευση",
  挑战任务: "Εργασίες πρόκλησης",
  注册认证任务: "Εργασία εγγραφής και επαλήθευσης",
  完成注册认证即可领取:
    "Ολοκληρώστε την εγγραφή και την επαλήθευση για να λάβετε",
  领取奖励: "Λήψη ανταμοιβής",
  新人豪礼: "Μπόνους καλωσορίσματος",
  "参与人数：": "Αριθμός συμμετεχόντων:",
  条件: "Προϋπόθεση",
  入金量: "Ποσό κατάθεσης",
  完成: "Ολοκληρώθηκε",
  任务奖励: "Ανταμοιβή εργασίας",
  距任务更新: "Μέχρι την ενημέρωση της εργασίας",
  "条件：": "Προϋπόθεση:",
  活动规则: "Κανόνες δραστηριότητας",
  奖励明细: "Λεπτομέρειες ανταμοιβής",
  已获得: "Αποκτήθηκε",
  交易奖励: "Ανταμοιβή συναλλαγών",
  Win奖励: "Ανταμοιβή WIN",
  已领取: "Ελήφθη",
  亏损金额超过: "Ποσό ζημίας υπερβαίνει",
  单笔开仓金额超过: "Ποσό μεμονωμένης εντολής υπερβαίνει",
  交易量: "Όγκος συναλλαγών",
  待完成: "Προς ολοκλήρωση",
  入金: "Κατάθεση",
  盈利金额超过: "Ποσό κέρδους υπερβαίνει",
  开仓金额: "Ποσό εντολής",
  开仓金: "Ποσό εντολής",
  盈利: "Κέρδος",
  亏损: "Ζημία",
  领取: "Λήψη",
  未领取: "Δεν ελήφθη",
  待领取: "Προς λήψη",
  再交易: "Συναλλαγή περαιτέρω",
  即可获得: "για να λάβετε",
  领取成功: "Επιτυχής λήψη",
  "1、所有的活动都会按照活动最后的时间进行统计收益过期后将无效。":
    "1. Όλες οι δραστηριότητες θα διακανονίζονται στην ημερομηνία λήξης. Οι ανταμοιβές λήγουν μετά από αυτό.",
  "2、获得的收益会发放到您的赏金账户中，你可以随时根据您的需要进行兑换和提现。":
    "2. Η κερδισμένη απόδοση θα πιστωθεί στον λογαριασμό ανταμοιβών σας, τον οποίο μπορείτε να ανταλλάξετε ή να κάνετε ανάληψη ανά πάσα στιγμή.",
  "3、获取的到的奖励币种类型根据任务按类型发放。":
    "3. Το κρυπτονόμισμα της ανταμοιβής εξαρτάται από την εργασία.",
  "4、最终解释权归平台所有，若发现存在异常手段套利平台的任务奖金，平台有权冻结并且清除您获取的收益。":
    "4. Η πλατφόρμα διατηρεί το δικαίωμα τελικής ερμηνείας. Σε περίπτωση εξαπάτησης σε εργασίες, οι ανταμοιβές θα παρακρατηθούν και ο λογαριασμός σας μπορεί να παγώσει.",
  成长学院: "Ακαδημία",
  "区块链 & 加密货币": "Blockchain & Κρυπτονόμισμα",
  "您的加密货币一站式指南，我们带您开启加密货币之路。":
    "Ο πλήρης οδηγός σας για τα κρυπτονομίσματα. Σας συνοδεύουμε στο ταξίδι σας στα κρυπτονομίσματα.",
  "全仓合约定单的全部保证金。":
    "Σύνολο περιθωρίου για εντολές συμβολαίων μελλοντικής εκπλήρωσης με διασταυρούμενο περιθώριο.",
  "(账户余额+(浮动盈亏-手续费-过夜费)=净值/已用保证金*100":
    "(Υπόλοιπο + (μη πραγματοποιηθέν κέρδος/ζημία - χρεώσεις - τόκοι χρηματοδότησης) = Καθαρή αξία / Χρησιμοποιηθέν περιθώριο * 100",
  "浮动盈亏会直接影响”可用保证金“，当未实现盈亏增加，可用保证金将会增加，未实现盈亏减少，可用保证金同样也会减少。":
    "Το μη πραγματοποιηθέν κέρδος/ζημία έχει άμεσο αντίκτυπο στο 'διαθέσιμο περιθώριο'. Εάν το μη πραγματοποιηθέν κέρδος/ζημία αυξηθεί, το διαθέσιμο περιθώριο αυξάνεται και αντίστροφα.",
  "账户余额-(已用保证金)+(浮动盈亏-手续费-过夜费)":
    "Υπόλοιπο - (Χρησιμοποιηθέν περιθώριο) + (μη πραγματοποιηθέν κέρδος/ζημία - χρεώσεις - τόκοι χρηματοδότησης)",
  "注:可继续用于开仓的保证金。":
    "Σημείωση: Περιθώριο που είναι διαθέσιμο για άνοιγμα νέων θέσεων.",
  "账户余额+(浮动盈亏-手续费-过夜费)":
    "Υπόλοιπο + (μη πραγματοποιηθέν κέρδος/ζημία - χρεώσεις - τόκοι χρηματοδότησης)",
  "注:当前的资金结余。": "Σημείωση: Τρέχον υπόλοιπο.",
  "指的是合约账户的全部余额，包含不可用余额。":
    "Αναφέρεται στο συνολικό υπόλοιπο του λογαριασμού συμβολαίων μελλοντικής εκπλήρωσης, συμπεριλαμβανομένων των παγωμένων ποσών.",
  "注:风险率越高，风险越低，风险率越低，风险越高。":
    "Σημείωση: Όσο υψηλότερο είναι το ποσοστό κινδύνου, τόσο χαμηλότερος ο κίνδυνος και αντίστροφα.",
  该功能尚未开发: "Αυτή η λειτουργία βρίσκεται ακόμη υπό ανάπτυξη",
  重置密码: "Επαναφορά κωδικού",
  "请输入为8-20位，必须包含字母、数字和特殊字符":
    "Εισάγετε 8-20 χαρακτήρες, συμπεριλαμβανομένων γραμμάτων, αριθμών και ειδικών χαρακτήρων",
  修改成功: "Επιτυχής αλλαγή",
  输入验证码: "Εισάγετε τον κωδικό επαλήθευσης",
  输入密码: "Εισάγετε τον κωδικό",
  详情说明: "Λεπτομέρειες",
  已售罄: "Εξαντλήθηκε",
  剩余期限: "Υπόλοιπη διάρκεια",
  限期: "Διάρκεια",
  闪兑货币选择: "Επιλογή νομίσματος για ταχεία ανταλλαγή",
  地区选择: "Επιλογή περιοχής",
  "搜索国家/地区": "Αναζήτηση χώρας/περιοχής",
  "身份信息已提交，将在*小时内审核完成":
    "Οι πληροφορίες ταυτότητας υποβλήθηκαν. Η επεξεργασία θα διαρκέσει έως * ώρες.",
  "选择国家/地区": "Επιλογή χώρας/περιοχής",
  "止盈价格需高于*": "Η τιμή ορίου κέρδους πρέπει να είναι υψηλότερη από *",
  "止损价格需低于*": "Η τιμή διακοπής ζημίας πρέπει να είναι χαμηλότερη από *",
  "止盈价格需低于*": "Η τιμή ορίου κέρδους πρέπει να είναι χαμηλότερη από *",
  "止损价格需高于*": "Η τιμή διακοπής ζημίας πρέπει να είναι υψηλότερη από *",
  教程详情: "Λεπτομέρειες σεμιναρίου",
  请输入止损价: "Εισάγετε τιμή διακοπής ζημίας",
  活期: "Ευέλικτο",
  赎回后立即到账: "Άμεση πίστωση μετά την εξαγορά",
  赎回: "Εξαγορά",
  赎回理财: "Εξαγορά χρηματοοικονομικού προϊόντος",
  是否赎回当前的理财订单:
    "Εξαγορά της τρέχουσας παραγγελίας χρηματοοικονομικού προϊόντος;",
  维护: "Συντήρηση",
  "系统正在维护中……": "Το σύστημα βρίσκεται σε συντήρηση...",
  合约: "Συμβόλαια μελλοντικής εκπλήρωσης",
  闪电兑换: "Ταχεία ανταλλαγή",
  流水挖矿: "Εξόρυξη όγκου",
  邀请豪礼: "Μπόνους πρόσκλησης",
  计算器: "Υπολογιστής",
  最新价: "Τελευταία τιμή",
  涨跌幅: "Μεταβολή (24h)",
  关注币种添加自选: "Προσθήκη κρυπτονομίσματος στα αγαπημένα",
  一键添加自选: "Προσθήκη στα αγαπημένα (ένα κλικ)",
  全标已读: "Επισήμανση όλων ως αναγνωσμένων",
  无消息: "Δεν υπάρχουν μηνύματα",
  "暂时还没有收到任何消息通知哦!": "Δεν έχετε λάβει ακόμη καμία ειδοποίηση!",
  没有更多数据: "Δεν υπάρχουν περαιτέρω δεδομένα",
  闪兑: "Ταχεία ανταλλαγή",
  从: "Από",
  "可用余额：": "Διαθέσιμο υπόλοιπο:",
  至: "Προς",
  预览兑换结果: "Προεπισκόπηση αποτελέσματος ανταλλαγής",
  闪兑规则: "Κανόνες ταχείας ανταλλαγής",
  "市场闪兑可能变动，请以实际到账的金额数量为准。":
    "Η ταχεία ανταλλαγή υπόκειται σε διακυμάνσεις της αγοράς. Το πραγματικά ληφθέν ποσό είναι δεσμευτικό.",
  "对汇兑率由第三方制定，由于兑换成本以及市场波动，您兑换的汇率可能会高于市场的汇率，请仔细确认后进行操作。":
    "Οι συναλλαγματικές ισοτιμίες καθορίζονται από τρίτους. Λόγω κόστους και διακυμάνσεων, η ισοτιμία ενδέχεται να διαφέρει από την ισοτιμία αγοράς. Ελέγξτε προσεκτικά.",
  "平台对每笔汇兑收取大约*%的手续费，用于支付在交易所兑换成本。":
    "Η πλατφόρμα χρεώνει περίπου *% χρέωση ανά ανταλλαγή για την κάλυψη του κόστους σε ανταλλακτήρια.",
  确认汇兑: "Επιβεβαίωση ανταλλαγής",
  您预估得到: "Εκτιμώμενη λήψη",
  汇兑: "Ανταλλαγή",
  汇兑比例: "Συναλλαγματική ισοτιμία",
  刷新: "Ανανέωση",
  兑换: "Ανταλλαγή",
  没有更多了: "Δεν υπάρχουν περαιτέρω δεδομένα",
  搜索币种: "Αναζήτηση κρυπτονομίσματος",
  可用: "Διαθέσιμο",
  我知道了: "Το κατάλαβα",
  最新价格: "Τελευταία τιμή",
  确认: "Επιβεβαίωση",
  最大: "Μέγιστο",
  "风险率(%)": "Ποσοστό κινδύνου (%)",
  当前委托: "Τρέχουσες εντολές",
  合作交易历史记录: "Ιστορικό συναλλαγών συνεργάτη",
  重置: "Επαναφορά",
  余额: "Υπόλοιπο",
  现货账户: "Λογαριασμός spot",
  合约账户: "Λογαριασμός συμβολαίων μελλοντικής εκπλήρωσης",
  WIN账户: "Λογαριασμός WIN",
  赏金账户: "Λογαριασμός ανταμοιβών",
  总资产折合: "Σύνολο περιουσιακών στοιχείων (σε USDT)",
  今日收益: "Απόδοση σήμερα",
  充币: "Κατάθεση",
  提币: "Ανάληψη",
  账户权益: "Αξία λογαριασμού",
  "数量/类别": "Ποσότητα/Κατηγορία",
  全部币种: "Όλα τα κρυπτονομίσματα",
  全部类型: "Όλοι οι τύποι",
  账单信息: "Πληροφορίες τιμολογίου",
  理财赎回: "Εξαγορά χρηματοοικονομικού προϊόντος",
  购买理财: "Αγορά χρηματοοικονομικού προϊόντος",
  收入: "Έσοδα",
  支出: "Έξοδα",
  到: "προς",
  资产划转: "Μεταφορά περιουσιακών στοιχείων",
  "最少*": "Ελάχιστο *",
  "可用资产：": "Διαθέσιμα περιουσιακά στοιχεία:",
  确认划转: "Επιβεβαίωση μεταφοράς",
  "只有将资产划转至对于的账户才可以进行交易，账户间的划转不收取手续费。":
    "Πρέπει να μεταφέρετε περιουσιακά στοιχεία στον σωστό λογαριασμό για να μπορέσετε να συναλλαγείτε. Οι μεταφορές μεταξύ λογαριασμών είναι δωρεάν.",
  币种账户选择: "Επιλογή λογαριασμού κρυπτονομίσματος",
  选择账户: "Επιλογή λογαριασμού",
  划转详情: "Λεπτομέρειες μεταφοράς",
  划转明细: "Προδιαγραφές μεταφοράς",
  收入账单: "Τιμολόγιο εσόδων",
  支出账单: "Τιμολόγιο εξόδων",
  金额: "Ποσό",
  总收益: "Συνολική απόδοση",
  佣金: "Προμήθεια",
  用户名: "Όνομα χρήστη",
  "已领取：": "Ελήφθη:",
  "未领取：": "Δεν ελήφθη:",
  "请选择国家/地区": "Επιλέξτε χώρα/περιοχή",
  请上传身份信息: "Μεταφορτώστε πληροφορίες ταυτότητας",
  请选择证件类型: "Επιλέξτε τύπο εγγράφου",
  请填写证件编码: "Εισάγετε αριθμό εγγράφου",
  请填写名字: "Εισάγετε όνομα",
  请填写姓氏: "Εισάγετε επώνυμο",
  投资金额: "Ποσό επένδυσης",
  天: "ημέρες",
  请输入手机号: "Εισάγετε αριθμό κινητού",
  搜索: "Αναζήτηση",
  搜索历史: "Ιστορικό αναζητήσεων",
  热门推荐: "Δημοφιλείς προτάσεις",
  "《Xspace Earn协议》": "Πρωτόκολλο Xspace Earn",
  我已了解并同意: "Το κατάλαβα και αποδέχομαι το",
  协议: "Πρωτόκολλο",
  Xspace官方中文交流群: "Επίσημη κινεζική κοινότητα Xspace",
  Xspace官方英文交流群: "Επίσημη αγγλική κοινότητα Xspace",
  预计维护至: "Αναμενόμενη συντήρηση έως",
  更多功能: "Περισσότερες λειτουργίες",
  下载APP: "Λήψη εφαρμογής",
  理财: "Χρηματοοικονομικό προϊόν",
  推荐: "Προτεινόμενο",
  Telegram官方中文频道: "Επίσημο κανάλι Telegram (Κινεζικά)",
  Telegram官方英文频道: "Επίσημο κανάλι Telegram (Αγγλικά)",
  官方邮箱: "Επίσημο email",
  客服邮箱: "Email εξυπηρέτησης πελατών",
  上述信息最终解释权归官方所有:
    "Οι παραπάνω πληροφορίες υπόκεινται στην επίσημη ερμηνεία της πλατφόρμας.",
  IOS版下载: "Λήψη για iOS",
  Android版下载: "Λήψη για Android",
  "手续费=买入手续费+资金费率+卖出手续费":
    "Χρέωση συναλλαγής = Χρέωση αγοράς + Επιτόκιο χρηματοδότησης + Χρέωση πώλησης",
  资金划转: "Μεταφορά κεφαλαίων",
  止盈: "Όριο κέρδους",
  止损: "Διακοπή ζημίας",
  自动平仓: "Αυτόματο κλείσιμο",
  委托挂单: "Ανοιχτή εντολή",
  买: "Αγορά",
  卖: "Πώληση",
  "买入/做多": "Αγορά/Long",
  "卖出/做空": "Πώληση/Short",
  详情: "Λεπτομέρειες",
  浮动涨跌: "Μη πραγματοποιηθέν κέρδος/ζημία",
  最小: "Ελάχιστο",
  充币数量: "Ποσότητα κατάθεσης",
  请输入充币数量: "Εισάγετε ποσότητα κατάθεσης",
  支付截图: "Απόδειξη πληρωμής",
  提交: "Υποβολή",
  上传驾驶证: "Μεταφόρτωση άδειας οδήγησης",
  上传护照: "Μεταφόρτωση διαβατηρίου",
  加载中: "Φόρτωση...",
  上传成功: "Επιτυχής μεταφόρτωση",
  充值历史: "Ιστορικό καταθέσεων",
  合约卖出手续费: "Χρέωση πώλησης συμβολαίων μελλοντικής εκπλήρωσης",
  合约买入手续费: "Χρέωση αγοράς συμβολαίων μελλοντικής εκπλήρωσης",
  系统加款: "Πίστωση συστήματος",
  系统减款: "Χρέωση συστήματος",
  合约资金费率: "Επιτόκιο χρηματοδότησης συμβολαίων μελλοντικής εκπλήρωσης",
  佣金分成: "Επιμερισμός προμήθειας",
  U本位合约: "Συμβόλαια μελλοντικής εκπλήρωσης με περιθώριο σε USDT",
  资产管理: "Διαχείριση περιουσιακών στοιχείων",
  APP下载: "Λήψη εφαρμογής",
  全球领先的数字理财平台:
    "Κορυφαία παγκόσμια πλατφόρμα ψηφιακής διαχείρισης περιουσιακών στοιχείων",
  "即刻交易比特币、以太坊等上百种数字资产":
    "Συναλλαγή άμεσα σε Bitcoin, Ethereum και εκατοντάδες άλλα ψηφιακά περιουσιακά στοιχεία",
  "24H涨跌幅": "Μεταβολή 24h",
  查看更多行情: "Δείτε περισσότερες αγορές",
  近24小时成交量: "Όγκος 24h",
  "提供数百种币币和合约交易对，以满足多样化的交易需求。 平台在200个国家和地区中有超过2千万用户，是全球领先的数字资产服务平台。":
    "Προσφέρει εκατοντάδες ζεύγη spot και συμβολαίων μελλοντικής εκπλήρωσης. Πάνω από 20 εκατομμύρια χρήστες σε 200+ χώρες. Μια κορυφαία παγκόσμια πλατφόρμα ψηφιακών περιουσιακών στοιχείων.",
  用户国家分布: "Χρήστες ανά χώρα",
  用户数: "Αριθμός χρηστών",
  交易对: "Ζεύγη συναλλαγών",
  服务支持: "Υποστήριξη",
  "随时随地，多平台终端交易":
    "Συναλλαγή οπουδήποτε με υποστήριξη πολλαπλών πλατφορμών",
  "多终端完美兼容，随时满足各种场景的交易需求。":
    "Συμβατό με πολλές συσκευές για όλες τις ανάγκες συναλλαγών.",
  随时查看实时行情: "Δείτε τιμές σε πραγματικό χρόνο οπουδήποτε",
  "轻松买卖BTC，ETH，DOGE和其他数字资产":
    "Αγοράστε και πουλήστε εύκολα BTC, ETH, DOGE και άλλα ψηφιακά περιουσιακά στοιχεία",
  获取您关注的加密货币价格变化预警:
    "Λάβετε ειδοποιήσεις τιμών για κρυπτονομίσματα που παρακολουθείτε",
  "查看比特币现货、期货、期权价格":
    "Δείτε τιμές Bitcoin spot, συμβολαίων μελλοντικής εκπλήρωσης και δικαιωμάτων προαίρεσης",
  比较各交易所加密货币价格:
    "Συγκρίνετε τιμές κρυπτονομισμάτων μεταξύ ανταλλακτηρίων",
  开启您的数字货币之旅:
    "Ξεκινήστε το ταξίδι σας στα ψηφιακά περιουσιακά στοιχεία",
  快捷购买数字货币: "Αγοράστε γρήγορα κρυπτονομίσματα",
  "使用多种支付方式交易数字货币，安全快捷":
    "Συναλλαγή με ασφάλεια και ταχύτητα με πολλαπλούς τρόπους πληρωμής",
  最优的交易费率: "Οι καλύτερες χρεώσεις συναλλαγών",
  "优惠的交易费率，富有竞争力的VIP权益，享受最优品质的服务":
    "Ανταγωνιστικές χρεώσεις, προνόμια VIP και υπηρεσίες υψηλής ποιότητας.",
  可信赖的安全保障: "Αξιόπιστη ασφάλεια",
  "我们复杂的安全措施和SAFU基金保护您的数字资产免受所有风险。":
    "Προηγμένα μέτρα ασφαλείας και το ταμείο SAFU προστατεύουν τα περιουσιακά σας στοιχεία από κινδύνους.",
  交易: "Συναλλαγή",
  币币市场: "Αγορά spot",
  "24H成交量": "Όγκος 24h",
  交易所: "Ανταλλακτήριο",
  "24H最高": "Υψηλό 24h",
  "24H最低": "Χαμηλό 24h",
  永续合约: "Διαιωνιζόμενα συμβόλαια μελλοντικής εκπλήρωσης",
  日涨跌: "Ημερήσια μεταβολή",
  交易深度: "Βάθος βιβλίου εντολών",
  "资产(合约)": "Περιουσιακά στοιχεία (Συμβόλαια μελλοντικής εκπλήρωσης)",
  历史仓位: "Ιστορικό θέσεων",
  兑换记录: "Ιστορικό ανταλλαγών",
  类型: "Τύπος",
  充值记录: "Ιστορικό καταθέσεων",
  划转记录: "Ιστορικό μεταφορών",
  类别: "Κατηγορία",
  历史账单: "Ιστορικό τιμολογίων",
  在线充值: "Διαδικτυακή κατάθεση",
  安全设置: "Ρυθμίσεις ασφαλείας",
  用于账户登录使用: "Χρησιμοποιείται για τη σύνδεση στο λογαριασμό",
  用户提现时安全验证使用:
    "Χρησιμοποιείται για επαλήθευση ασφαλείας κατά τις αναλήψεις",
  验证: "Επαλήθευση",
  万: "εκατομμύριο",
  随时随地开启交易: "Ξεκινήστε τις συναλλαγές οπουδήποτε",
  "*货币交易所的所有功能尽在你的手中。":
    "Όλες οι λειτουργίες του ανταλλακτηρίου * στο χέρι σας.",
  "下载*货币交易所APP。": "Κατεβάστε την εφαρμογή του ανταλλακτηρίου *.",
  下载自: "Λήψη από",
  内测版: "Έκδοση beta",
  下载: "Λήψη",
  扫码下载: "Σάρωση για λήψη",
  设置您的资产密码: "Ορίστε τον κωδικό περιουσιακών στοιχείων σας",
  法币: "Fiat",
  我要买: "Θέλω να αγοράσω",
  我要卖: "Θέλω να πουλήσω",
  请输入金额: "Εισάγετε ποσό",
  汇率: "Συναλλαγματική ισοτιμία",
  获得: "Λήψη",
  支付通道: "Κανάλι πληρωμής",
  收款通道: "Κανάλι παραλαβής",
  "出售过程需要务必确认好您的收款方式为本人。":
    "Βεβαιωθείτε ότι το κανάλι παραλαβής είναι στο όνομά σας όταν πουλάτε.",
  当前法币暂不支持交易对可尝试前往提现:
    "Αυτό το ζεύγος fiat δεν υποστηρίζεται προς το παρόν. Δοκιμάστε ανάληψη.",
  前往提现: "Μετάβαση σε ανάληψη",
  该法币暂无通道: "Δεν υπάρχει διαθέσιμο κανάλι για αυτό το fiat",
  "正在出售中，请耐心等待":
    "Η πώληση βρίσκεται σε εξέλιξη, παρακαλώ περιμένετε",
  请选择支付通道: "Επιλέξτε κανάλι πληρωμής",
  请选择方式: "Επιλέξτε μέθοδο",
  法币历史: "Ιστορικό fiat",
  买币: "Αγορά κρυπτονομίσματος",
  卖币: "Πώληση κρυπτονομίσματος",
  失败: "Απέτυχε",
  已完成: "Ολοκληρώθηκε",
  未付款: "Απλήρωτο",
  待审核: "Σε αναμονή",
  打款中: "Η πληρωμή βρίσκεται σε εξέλιξη",
  订单详情: "Λεπτομέρειες παραγγελίας",
  联系客服: "Επικοινωνία με υποστήριξη",
  到账金额: "Ποσό παραλαβής",
  通道: "Κανάλι",
  收款人: "Δικαιούχος",
  收款账户: "Λογαριασμός δικαιούχου",
  "订单出售失败，请查下方失败原因":
    "Η πώληση της παραγγελίας απέτυχε. Δείτε την αιτία παρακάτω.",
  失败原因: "Αιτία αποτυχίας",
  您还未进行付款: "Δεν έχετε πληρώσει ακόμα",
  您已成功购买: "Η αγορά ήταν επιτυχής",
  已取消订单: "Η παραγγελία ακυρώθηκε",
  "订单正在审核中，请耐心等待":
    "Η παραγγελία βρίσκεται υπό επεξεργασία. Παρακαλώ περιμένετε.",
  您已成功出售: "Η πώληση ήταν επιτυχής",
  "订单正在打款中，请耐心等待":
    "Η πληρωμή βρίσκεται σε εξέλιξη. Παρακαλώ περιμένετε.",
  "支付过程需要您前往其他的平台进行支付订单，请注意信息安全。":
    "Για την πληρωμή, πρέπει να επισκεφτείτε άλλη πλατφόρμα. Δώστε προσοχή στην ασφάλεια των πληροφοριών σας.",
  当前法币暂不支持交易对可尝试前往充值:
    "Αυτό το ζεύγος fiat δεν υποστηρίζεται προς το παρόν. Δοκιμάστε κατάθεση.",
  前往充值: "Μετάβαση σε κατάθεση",
  购买: "Αγορά",
  订单号: "Αριθμός παραγγελίας",
  单价: "Τιμή μονάδας",
  到账数量: "Ποσότητα παραλαβής",
  "当前存在未付的订单，是否继续发起新的支付订单？":
    "Υπάρχει μια απλήρωτη παραγγελία. Να ξεκινήσει μια νέα παραγγελία πληρωμής;",
  继续支付: "Συνέχεια πληρωμής",
  重新下单: "Νέα παραγγελία",
  是否确定出售: "Είστε σίγουροι ότι θέλετε να πουλήσετε;",
  "确定出售后，平台将分配给买家，请耐心等待平台的撮合。":
    "Μετά την επιβεβαίωση, η πλατφόρμα θα εκχωρήσει έναν αγοραστή. Περιμένετε την αντιστοίχιση.",
  出售: "Πώληση",
  收款方式: "Μέθοδος παραλαβής",
  订单已生成: "Η παραγγελία δημιουργήθηκε",
  取消订单: "Ακύρωση παραγγελίας",
  请在: "Παρακαλώ εντός",
  内完成付款: "ολοκληρώστε την πληρωμή",
  "离开平台，登录您指定的支付，转账到卖家的以下账户，并务必在付款中备注：":
    "Αποχωρήστε από την πλατφόρμα, συνδεθείτε στην επιλεγμένη μέθοδο πληρωμής σας και μεταφέρετε το ποσό στον παρακάτω λογαριασμό του πωλητή. Αναφέρετε πάντα την αναφορά:",
  "若付款时未进行备注，卖家将无法确认收款，造成资产损失无法找回。":
    "Χωρίς αναφορά, ο πωλητής δεν θα μπορεί να επιβεβαιώσει την πληρωμή, γεγονός που μπορεί να οδηγήσει σε απώλεια περιουσιακών στοιχείων.",
  "未在规定的时间内付款，订单都将被取消。":
    "Εάν δεν πληρώσετε εντός του καθορισμένου χρόνου, η παραγγελία θα ακυρωθεί.",
  姓名: "Όνομα",
  收款姓名: "Όνομα δικαιούχου",
  开户支行: "Υποκατάστημα τράπεζας",
  银行卡号: "Αριθμός τραπεζικής κάρτας",
  "付款后，返回本平台": "Μετά την πληρωμή, επιστρέψτε σε αυτήν την πλατφόρμα",
  "请务必点击下方“我已完成付款，通知卖家”按钮":
    "Κάντε κλικ στο κουμπί 'Ολοκλήρωσα την πληρωμή, ειδοποίηση πωλητή'",
  未点击卖家不会放款:
    "Ο πωλητής θα ελευθερώσει το κρυπτονόμισμα μόνο αφού κάνετε κλικ στο κουμπί",
  交易条款: "Όροι συναλλαγής",
  "购买资金来源，必须合法安全的资金，方可交易":
    "Τα κεφάλαια για την αγορά πρέπει να είναι νόμιμα και ασφαλή",
  "不允许诈骗、传销、赌博或者其他非法资金交易":
    "Απάτη, πυραμίδες, τζόγος ή άλλα παράνομα κεφάλαια δεν επιτρέπονται",
  "交易完成后，出现资金风险，被冻结或者涉嫌欺诈、传销、赌博的资金，我方将不在向买方放U，并给予退款":
    "Εάν μετά τη συναλλαγή τα κεφάλαια παγώσουν ή είναι ύποπτα, δεν θα ελευθερώσουμε τα USDT και θα προβούμε σε επιστροφή χρημάτων",
  "已付款，通知卖家": "Πληρώθηκε, ειδοποίηση πωλητή",
  "买方当日累计取消*笔订单，将会取消当日购买功能。确定取消该订单吗？":
    "Εάν ακυρώσετε συνολικά * παραγγελίες σήμερα, το δικαίωμα αγοράς σας για σήμερα θα ανακληθεί. Να ακυρωθεί αυτή η παραγγελία;",
  添加收款方式: "Προσθήκη μεθόδου παραλαβής",
  是否删除此收款方式: "Διαγραφή αυτής της μεθόδου παραλαβής;",
  删除: "Διαγραφή",
  请选择法币: "Επιλέξτε fiat νόμισμα",
  机构名称: "Όνομα ιδρύματος",
  请选择机构: "Επιλέξτε ίδρυμα",
  "当您出售数字货币时，您选择的收款方式将向买方展示，请确认填写无误。":
    "Η επιλεγμένη μέθοδος παραλαβής σας θα εμφανίζεται στους αγοραστές όταν πουλάτε κρυπτονομίσματα. Βεβαιωθείτε ότι τα στοιχεία είναι σωστά.",
  请选择银行: "Επιλέξτε τράπεζα",
  请输入姓名: "Εισάγετε όνομα",
  账号: "Αριθμός λογαριασμού",
  请输入账号: "Εισάγετε αριθμό λογαριασμού",
  收款码: "Κωδικός παραλαβής",
  "银行账号/卡号": "Τραπεζικός λογαριασμός/Αριθμός κάρτας",
  "请输入银行账号/卡号": "Εισάγετε τραπεζικό λογαριασμό/αριθμό κάρτας",
  "开户支行（选填）": "Υποκατάστημα τράπεζας (προαιρετικό)",
  请输入开户支行: "Εισάγετε υποκατάστημα τράπεζας",
  "加入*官方频道": "Γίνετε μέλος του επίσημου καναλιού *",
  关于: "Σχετικά",
  条款: "Όροι",
  成功: "Επιτυχία",
  等待: "Αναμονή",
  作废: "Άκυρο",
  确认付款: "Επιβεβαίωση πληρωμής",
  "是否已完成付款？若确认付款后，商家将会在*分内进行确认是否收到付款。":
    "Η πληρωμή ολοκληρώθηκε; Μετά την επιβεβαίωση, ο πωλητής θα ελέγξει την παραλαβή εντός * λεπτών.",
  最大金额: "Μέγιστο ποσό",
  最小金额: "Ελάχιστο ποσό",
  付款: "Πληρωμή",
  法币充值: "Κατάθεση fiat",
  法币提现: "Ανάληψη fiat",
  待支付: "Προς πληρωμή",
  已支付: "Πληρωμένο",
  商户名: "Όνομα πωλητή",
  当前没有添加支付方式: "Δεν έχει προστεθεί μέθοδος πληρωμής",
  添加后再出售: "Προσθέστε μία πριν πουλήσετε",
  新人大礼包: "Πακέτο καλωσορίσματος",
  注册即可领取: "Λάβετε μετά την εγγραφή",
  立即领取: "Λήψη τώρα",
  不再提示: "Να μην εμφανίζεται ξανά",
  "该奖励需在APP中领取，请下载APP":
    "Αυτή η ανταμοιβή μπορεί να ληφθεί μόνο στην εφαρμογή. Κάντε λήψη της εφαρμογής.",
  去交易: "Μετάβαση σε συναλλαγές",
  期权交易: "Συναλλαγή δικαιωμάτων προαίρεσης",
  交易额: "Ποσό συναλλαγής",
  可用额度: "Διαθέσιμο όριο",
  交易周期: "Περίοδος συναλλαγής",
  看涨: "Ανοδικό (Call)",
  看跌: "Καθοδικό (Put)",
  看空: "Short",
  当前持有: "Τρέχουσα θέση",
  胜率: "Ποσοστό επιτυχίας",
  "盈利/亏损数": "Αριθμός συναλλαγών με κέρδος/ζημία",
  累计实现盈亏: "Πραγματοποιηθέν συνολικό κέρδος/ζημία",
  秒: "δευτερόλεπτα",
  分: "λεπτά",
  小时: "ώρες",
  周: "εβδομάδα",
  下单时间: "Ώρα παραγγελίας",
  剩余时间: "Υπόλοιπος χρόνος",
  买入价: "Τιμή αγοράς",
  结算价: "Τιμή διακανονισμού",
  实现盈利: "Πραγματοποιηθέν κέρδος",
  结算时间: "Ώρα διακανονισμού",
  期权: "Δικαίωμα προαίρεσης",
  新手教程: "Οδηγός για αρχάριους",
  我的订单: "Οι παραγγελίες μου",
  赔率: "Απόδοση",
  全部订单: "Όλες οι παραγγελίες",
  持有订单: "Ανοιχτές παραγγελίες",
  历史订单: "Ιστορικό παραγγελιών",
  输入交易额度: "Εισάγετε ποσό συναλλαγής",
  选择交易周期: "Επιλέξτε περίοδο συναλλαγής",
  去注册: "Εγγραφή",
  冻结: "Πάγωμα",
  期权支出: "Δαπάνη δικαιωμάτων προαίρεσης",
  期权收入: "Έσοδο δικαιωμάτων προαίρεσης",
  用户提现: "Ανάληψη χρήστη",
  "是否购买？": "Αγορά αυτού του δικαιώματος προαίρεσης;",
  购买成功: "Επιτυχής αγορά",
  请签名: "Παρακαλώ υπογράψτε",
  提交签名: "Υποβολή υπογραφής",
  清空签名: "Εκκαθάριση υπογραφής",
  签名审核中: "Η υπογραφή βρίσκεται υπό επεξεργασία",
  已提交: "Υποβλήθηκε",
  扫一扫下载APP: "Σάρωση για λήψη της εφαρμογής",
  新手领取大礼包: "Πακέτο καλωσορίσματος για νέους χρήστες",
  注册实名即送彩金: "Εγγραφείτε και επαληθευτείτε για να λάβετε μπόνους",
  交易总额: "Συνολικός όγκος συναλλαγών",
  资产不足: "Ανεπαρκή περιουσιακά στοιχεία",
  "Win账户的资产不足，可从资金账户划转至此账户":
    "Ανεπαρκή περιουσιακά στοιχεία στο λογαριασμό WIN. Μπορείτε να μεταφέρετε περιουσιακά στοιχεία από τον κύριο λογαριασμό σας.",
  Win: "WIN",
  比赛: "Διαγωνισμός",
  未开始: "Δεν ξεκίνησε",
  赛程: "Πρόγραμμα",
  赛果: "Αποτέλεσμα",
  已结束: "Ολοκληρώθηκε",
  让球: "Handicap",
  进球数: "Γκολ",
  大: "Πάνω (Over)",
  小: "Κάτω (Under)",
  胜负平: "1X2 (Νίκη/Ισοπαλία/Ήττα)",
  和局: "Ισοπαλία",
  投注: "Στοίχημα",
  下注金额: "Ποσό στοιχήματος",
  下注: "Τοποθέτηση στοιχήματος",
  阵容: "Σύνθεση",
  分析: "Ανάλυση",
  输入下注金额: "Εισάγετε ποσό στοιχήματος",
  下注成功: "Επιτυχής τοποθέτηση στοιχήματος",
  投注记录: "Ιστορικό στοιχημάτων",
  未结算: "Δεν έχει διακανονιστεί",
  已结算: "Έχει διακανονιστεί",
  流水: "Όγκος",
  输赢: "Κέρδος/Ζημία",
  赛时: "Ώρα αγώνα",
  下注时间: "Ώρα στοιχήματος",
  足彩竞猜: "Πρόβλεψη ποδοσφαίρου",
  查看详情: "Δείτε λεπτομέρειες",
  输: "Ζημία",
  赢: "Κέρδος",
  主: "Γηπεδούχος",
  客: "Φιλοξενούμενος",
  主胜: "Νίκη γηπεδούχου",
  客胜: "Νίκη φιλοξενούμενου",
  平: "Ισοπαλία",
  已延期: "Αναβλήθηκε",
  账号异常: "Ανωμαλία λογαριασμού",
  全场独赢: "1X2 Πλήρους αγώνα",
  全场让球: "Handicap πλήρους αγώνα",
  全场大小: "Πάνω/Κάτω πλήρους αγώνα",
  总进球: "Σύνολο γκολ",
  拍摄照片要求: "Απαιτήσεις φωτογραφίας",
  标准拍摄: "Τυπική φωτογραφία",
  边框缺失: "Λείπει το πλαίσιο",
  照片模糊: "Θολή φωτογραφία",
  闪光强烈: "Πολύ έντονο φλας",
  上传手持证件照: "Μεταφόρτωση φωτογραφίας με έγγραφο στο χέρι",
  上传证件照: "Μεταφόρτωση φωτογραφίας εγγράφου",
  换一张: "Νέα φωτογραφία",
  出生日期: "Ημερομηνία γέννησης",
  请选择出生日期: "Επιλέξτε ημερομηνία γέννησης",
  "输入下方正确的图形验证后，获取邮箱验证码进行注册":
    "Εισάγετε τον παρακάτω κωδικό επαλήθευσης για να λάβετε έναν κωδικό μέσω email για εγγραφή.",
  "您还剩余*次认证次数，超出次数将无法继续认证":
    "Έχετε ακόμα * προσπάθειες επαλήθευσης. Μετά από αυτό το όριο, δεν θα μπορείτε να επαληθευτείτε.",
  上半场: "Α' ημίχρονο",
  下半场: "Β' ημίχρονο",
  独赢: "1X2",
  上半场独赢: "Α' ημίχρονο 1X2",
  下半场独赢: "Β' ημίχρονο 1X2",
  上半场让球: "Α' ημίχρονο Handicap",
  下半场让球: "Β' ημίχρονο Handicap",
  上半场大小球: "Α' ημίχρονο Πάνω/Κάτω",
  下半场大小球: "Β' ημίχρονο Πάνω/Κάτω",
  波胆: "Ακριβές σκορ",
  上半场波胆: "Α' ημίχρονο Ακριβές σκορ",
  下半场波胆: "Β' ημίχρονο Ακριβές σκορ",
  单双: "Μονό/Ζυγό",
  单: "Μονό",
  双: "Ζυγό",
  上半场单双: "Α' ημίχρονο Μονό/Ζυγό",
  下半场单双: "Β' ημίχρονο Μονό/Ζυγό",
  上半场总进球: "Α' ημίχρονο Σύνολο γκολ",
  下半场总进球: "Β' ημίχρονο Σύνολο γκολ",
  中场: "Ημίχρονο",
  "注意：手持证件照请按照此示例图在白纸上书写文字并与证件一起拍摄":
    "Σημείωση: Για τη φωτογραφία με το έγγραφο στο χέρι, γράψτε το κείμενο σε ένα λευκό φύλλο χαρτιού και φωτογραφήστε το μαζί με το έγγραφό σας, όπως στο παράδειγμα.",
  "近期发现大量作弊账户，对一批违规账户进行了惩罚。如果有误判为违规账户，请联系在线客服。":
    "Πρόσφατα, πολλοί δόλιοι λογαριασμοί τιμωρήθηκαν. Επικοινωνήστε με την υποστήριξη εάν πιστεύετε ότι ο λογαριασμός σας τιμωρήθηκε άδικα.",
  最小下注金额: "Ελάχιστο στοίχημα",
  参与活动最小下注金额: "Ελάχιστο στοίχημα για συμμετοχή στη δραστηριότητα",
  记住密码: "Απομνημόνευση κωδικού",
  比分: "Σκορ",
  "您还未登录，请先登录": "Δεν έχετε συνδεθεί. Συνδεθείτε πρώτα.",
  立即登录: "Σύνδεση τώρα",
  下注限额: "Όριο στοιχήματος",
  可赢金额: "Ποσό που μπορείτε να κερδίσετε",
  闪兑详情: "Λεπτομέρειες ταχείας ανταλλαγής",
  大小球: "Πάνω/Κάτω",
  "由于汇率原因，下注金额和实际下注金额会有误差，请以订单为准。":
    "Λόγω διακυμάνσεων της συναλλαγματικής ισοτιμίας, το τελικό ποσό στοιχήματος ενδέχεται να διαφέρει. Η παραγγελία είναι δεσμευτική.",
  开赛时间: "Ώρα έναρξης",
  足球收入: "Έσοδα ποδοσφαίρου",
  足球支出: "Έξοδα ποδοσφαίρου",
  活动详情: "Λεπτομέρειες δραστηριότητας",
  为世界杯喝彩: "Υποστηρίξτε το Παγκόσμιο Κύπελλο",
  我的竞猜: "Οι προβλέψεις μου",
  "竞猜比赛、有机会瓜分*USDT":
    "Προβλέψτε αγώνες και κερδίστε ένα μερίδιο από * USDT",
  "瓜分*USDT": "Μοιραστείτε * USDT",
  距离活动结束还有: "Απομένει μέχρι το τέλος της δραστηριότητας:",
  我的门票: "Τα εισιτήριά μου",
  竞猜结束时间: "Λήξη προβλέψεων",
  猜比分: "Πρόβλεψη σκορ",
  "福利派送中，完成任务即可获取门票":
    "Τα μπόνους διανέμονται. Ολοκληρώστε εργασίες για να κερδίσετε εισιτήρια.",
  "完成如下任务，可获对应数量门票的参与竞赛":
    "Ολοκληρώστε τις παρακάτω εργασίες για να λάβετε τον αντίστοιχο αριθμό εισιτηρίων για συμμετοχή στο διαγωνισμό.",
  时: "ώρα",
  活动: "Δραστηριότητα",
  竞猜记录: "Ιστορικό προβλέψεων",
  结果: "Αποτέλεσμα",
  任务: "Εργασία",
  去邀请: "Πρόσκληση",
  "每场比赛的比分竞猜，参与竞猜可瓜分$*美金的奖励。":
    "Προβλέψτε το σκορ κάθε αγώνα και κερδίστε ένα μερίδιο από $*.",
  "参与竞猜需要门票，门票可按照平台的任务进行获得。":
    "Απαιτείται εισιτήριο για πρόβλεψη. Τα εισιτήρια μπορούν να κερδηθούν ολοκληρώνοντας εργασίες της πλατφόρμας.",
  "竞猜成功后，把竞猜结果的截图发送给客服，客服会把奖金划入您的资金账户，你可以立即提取。":
    "Μετά από μια επιτυχημένη πρόβλεψη, στείλτε ένα στιγμιότυπο οθόνης στην υποστήριξη. Θα πιστώσουν το μπόνους στο λογαριασμό σας, το οποίο μπορείτε να κάνετε άμεσα ανάληψη.",
  "禁止任何作弊行为、如果发现作弊行为，奖励无效。":
    "Η εξαπάτηση απαγορεύεται. Εάν εντοπιστεί, η ανταμοιβή θα ακυρωθεί.",
  "完成任务后，点击咨询客服获得门票。":
    "Αφού ολοκληρώσετε τις εργασίες, κάντε κλικ στην 'Επικοινωνία με υποστήριξη' για να λάβετε εισιτήρια.",
  继续猜: "Συνέχεια προβλέψεων",
  总单数: "Συνολικός αριθμός στοιχημάτων",
  赛事筛选: "Φίλτρο ανά διοργάνωση",
  球队筛选: "Φίλτρο ανά ομάδα",
  总金额: "Συνολικό ποσό",
  总流水: "Συνολικός όγκος",
  派奖金额: "Ποσό μπόνους που καταβλήθηκε",
  下注单数: "Αριθμός στοιχημάτων",
  利润: "Κέρδος",
  更多福利: "Περισσότερα μπόνους",
  我的奖金: "Το μπόνους μου",
  未认证: "Δεν έχει επαληθευτεί",
  总量: "Σύνολο",
  或: "ή",
  模拟交易: "Προσομοίωση συναλλαγών",
  体验账户不可操作: "Δεν είναι διαθέσιμο σε λογαριασμό επίδειξης",
  世界杯比分竞猜: "Πρόβλεψη σκορ Παγκοσμίου Κυπέλλου",
  "领*USDT起": "Λάβετε από * USDT",
  消息: "Μηνύματα",
  滚球: "Live στοιχήματα",
  是: "Ναι",
  不是: "Όχι",
  当前余额: "Τρέχον υπόλοιπο",
  KOL招募: "Πρόσληψη KOL",
  本月净输赢: "Καθαρό κέρδος/ζημία αυτόν τον μήνα",
  本月佣金: "Προμήθεια αυτόν τον μήνα",
  佣金比例: "Ποσοστό προμήθειας",
  活跃人数: "Ενεργοί χρήστες",
  新增下级: "Νέοι downline",
  登录人数: "Χρήστες που συνδέθηκαν",
  首存人数: "Χρήστες πρώτης κατάθεσης",
  数据分析: "Ανάλυση δεδομένων",
  人数: "Αριθμός ατόμων",
  新注册存款金额: "Ποσό κατάθεσης νέων εγγραφών",
  老用户存款金额: "Ποσό κατάθεσης υφιστάμενων χρηστών",
  首存金额: "Ποσό πρώτης κατάθεσης",
  快捷入口: "Γρήγορη πρόσβαση",
  成员管理: "Διαχείριση μελών",
  财务报表: "Οικονομικές καταστάσεις",
  分红报表: "Αναφορά μερίσματος",
  订单记录: "Ιστορικό παραγγελιών",
  VIP专享: "Αποκλειστικό VIP",
  推广工具: "Εργαλεία προώθησης",
  计算规则: "Κανόνες υπολογισμού",
  账变明细: "Λεπτομέρειες συναλλαγής",
  成员: "Μέλη",
  下级概览: "Επισκόπηση downline",
  下级成员总计: "Σύνολο downline",
  本月新增: "Νέοι αυτόν τον μήνα",
  本月活跃会员: "Ενεργά μέλη αυτόν τον μήνα",
  今日活跃会员: "Ενεργά μέλη σήμερα",
  本月有效活跃: "Ενεργά αποτελεσματικά αυτόν τον μήνα",
  活跃成员占比: "Ποσοστό ενεργών μελών",
  本月活跃: "Ενεργά αυτόν τον μήνα",
  今日活跃: "Ενεργά σήμερα",
  下级成员: "Downline",
  会员账号: "Λογαριασμός μέλους",
  统计时间: "Ώρα στατιστικής",
  筛选: "Φίλτρο",
  存款: "Κατάθεση",
  取款: "Ανάληψη",
  总输赢: "Συνολικό κέρδος/ζημία",
  是否有效用户: "Ενεργός χρήστης;",
  最近登录时间: "Τελευταία σύνδεση",
  否: "Όχι",
  开始时间: "Ώρα έναρξης",
  结束时间: "Ώρα λήξης",
  提取: "Ανάληψη",
  总盈亏: "Συνολικό αποτέλεσμα",
  净盈亏: "Καθαρό αποτέλεσμα",
  分红: "Μέρισμα",
  概览: "Επισκόπηση",
  月度详细数据: "Λεπτομερή μηνιαία δεδομένα",
  未发放: "Δεν καταβλήθηκε",
  活跃用户: "Ενεργοί χρήστες",
  有效新增会员: "Αποτελεσματικά νέα μέλη",
  冲正后净输赢: "Καθαρό κέρδος/ζημία μετά από διόρθωση",
  上月结余: "Υπόλοιπο προηγούμενου μήνα",
  净输赢: "Καθαρό κέρδος/ζημία",
  "系统每日新加坡时间1:00更新一次报表":
    "Οι αναφορές ενημερώνονται καθημερινά στη 01:00 ώρα Σιγκαπούρης.",
  "报表中数据、总输赢、净输赢中正数表示代理方盈利、负数表示代理方亏损":
    "Στις αναφορές, οι θετικοί αριθμοί σημαίνουν κέρδος για τον συνεργάτη, οι αρνητικοί αριθμοί σημαίνουν ζημία για τον συνεργάτη.",
  "佣金数据每天进行更新，仅供参考，并不做实际佣金派发标准":
    "Τα δεδομένα προμήθειας ενημερώνονται καθημερινά, είναι ενδεικτικά και δεν αποτελούν οριστική βάση πληρωμής.",
  选择时间: "Επιλογή χρόνου",
  足球: "Ποδόσφαιρο",
  投注金额: "Ποσό στοιχήματος",
  有效订单: "Έγκυρες παραγγελίες",
  下级账户: "Λογαριασμός downline",
  待成交: "Σε αναμονή",
  下单金额: "Ποσό παραγγελίας",
  订单内容: "Περιεχόμενο παραγγελίας",
  秒数: "Δευτερόλεπτα",
  联赛: "Πρωτάθλημα",
  队伍: "Ομάδα",
  比赛时间: "Ώρα αγώνα",
  玩法: "Τύπος στοιχήματος",
  等级规则表: "Πίνακας κανόνων επιπέδου",
  等级: "Επίπεδο",
  活跃会员: "Ενεργά μέλη",
  最新活跃: "Τελευταία δραστηριότητα",
  额外佣金: "Επιπλέον προμήθεια",
  "每月按照对应等级的增长标准与奖励制度执行，只可享受一个等级奖励。":
    "Μηνιαία βάσει προτύπων ανάπτυξης. Μπορείτε να επωφεληθείτε μόνο από ένα επίπεδο.",
  渠道生成: "Δημιουργία καναλιού",
  创建: "Δημιουργία",
  渠道名称: "Όνομα καναλιού",
  注册人数: "Αριθμός εγγραφών",
  浏览人数: "Αριθμός προβολών",
  构建状态: "Κατάσταση κατασκευής",
  禁用: "Απενεργοποίηση",
  启用: "Ενεργοποίηση",
  查看: "Προβολή",
  创建渠道: "Δημιουργία καναλιού",
  创建成功: "Επιτυχής δημιουργία",
  操作成功: "Επιτυχής ενέργεια",
  渠道详情: "Λεπτομέρειες καναλιού",
  邀请码: "Κωδικός πρόσκλησης",
  访问人数: "Αριθμός επισκεπτών",
  渠道地址: "Διεύθυνση καναλιού",
  我的福利: "Τα μπόνους μου",
  充值福利: "Μπόνους κατάθεσης",
  当前流水: "Τρέχων όγκος",
  如何参与: "Πώς να συμμετάσχετε",
  币种充值: "Κατάθεση κρυπτονομίσματος",
  充值福利中领取福利: "Λήψη μπόνους στο μπόνους κατάθεσης",
  "规则：充值福利自愿领取，有效期为充值后的24小时内，过期无效，领取后将暂时锁定提现功能，当流水达到后即可解锁提现。":
    "Κανόνας: Το μπόνους κατάθεσης είναι προαιρετικό, ισχύει για 24 ώρες μετά την κατάθεση. Μετά τη λήψη, η ανάληψη μπλοκάρεται προσωρινά μέχρι να επιτευχθεί η απαίτηση όγκου.",
  失效日期: "Ημερομηνία λήξης",
  "暂无福利领取，充值后领取":
    "Δεν υπάρχει διαθέσιμο μπόνους. Λάβετε μετά την κατάθεση.",
  参与: "Συμμετοχή",
  充值赠送: "Μπόνους κατάθεσης",
  "领取*%的赠送": "Λάβετε *% μπόνους",
  去领取: "Λήψη",
  VIP奖励: "Ανταμοιβή VIP",
  "当前可领取*USDT，是否确认领取": "* USDT διαθέσιμα για λήψη. Επιβεβαίωση;",
  "领取后将临时锁定提现功能，当您的流水到达*USDT后即可解除锁定":
    "Μετά τη λήψη, η ανάληψη μπλοκάρεται προσωρινά μέχρι να επιτευχθεί όγκος * USDT.",
  充值送大礼: "Δώρο κατάθεσης",
  "存入越多，送越多！": "Όσο περισσότερα καταθέτετε, τόσο μεγαλύτερο το δώρο!",
  无效: "Άκυρο",
  有效: "Έγκυρο",
  总存金额: "Συνολικό ποσό κατάθεσης",
  提示: "Σημείωση",
  "总输赢，净输赢中正数表示平台盈利，负数表示亏损，每天数据只做参考，并不做实际佣金派发标准。":
    "Οι θετικοί αριθμοί στο συνολικό και καθαρό κέρδος/ζημία σημαίνουν κέρδος πλατφόρμας. Τα ημερήσια δεδομένα είναι ενδεικτικά.",
  "净盈亏：总盈亏-用户返水":
    "Καθαρό αποτέλεσμα: Συνολικό αποτέλεσμα - Cashback στον χρήστη",
  盈利方: "Μέρος με κέρδος",
  代理: "Αντιπρόσωπος",
  客户: "Πελάτης",
  平局: "Ισοπαλία",
  平台: "Πλατφόρμα",
  "已提交审核，请耐心等待": "Υποβλήθηκε για επαλήθευση. Παρακαλώ περιμένετε.",
  充值日期: "Ημερομηνία κατάθεσης",
  平台本月总输赢: "Συνολικό κέρδος/ζημία πλατφόρμας αυτόν τον μήνα",
  KOL招募合作: "Συνεργασία πρόσληψης KOL",
  "平台现在开放【KOL招募活动】，只要您有社群媒体号，就可以和平台享受分红一次性推广客户，就可以享受终生收益。":
    "Η πλατφόρμα ανοίγει την πρόσληψη KOL. Με έναν λογαριασμό κοινωνικής δικτύωσης, μπορείτε να απολαύσετε μερίσματα και δια βίου έσοδα μέσω εφάπαξ προώθησης πελατών.",
  级别: "Επίπεδο",
  平台利润返佣: "Προμήθεια κέρδους πλατφόρμας",
  佣金案例: "Παράδειγμα προμήθειας",
  交易项目: "Προϊόντα συναλλαγών",
  "期权交易、合约交易、足球游戏":
    "Συναλλαγή δικαιωμάτων προαίρεσης, συναλλαγή συμβολαίων μελλοντικής εκπλήρωσης, παιχνίδια ποδοσφαίρου",
  报名方式: "Μέθοδος εγγραφής",
  点击KOL招募报名: "Κάντε κλικ για να εγγραφείτε στην πρόσληψη KOL",
  "欢迎加入我们的团队，平台全面扶持您建立属于自己的用户体系，最高可得*的佣金，我们期待您加入。":
    "Καλώς ήρθατε στην ομάδα μας. Σας υποστηρίζουμε στη δημιουργία του δικού σας συστήματος χρηστών. Κερδίστε έως *% προμήθεια. Ανυπομονούμε για τη συμμετοχή σας.",
  输入联系方式: "Εισάγετε στοιχεία επικοινωνίας",
  最低活跃人数: "Ελάχιστος αριθμός ενεργών χρηστών",
  "如：本月活跃人数≥*并且本月平台总输赢≥*USDT，您属于等级*，即可得到*%的佣金。":
    "Π.χ.: Εάν ενεργοί χρήστες αυτόν τον μήνα ≥ * και συνολικό κέρδος/ζημία πλατφόρμας ≥ * USDT, ανήκετε στο επίπεδο * και λαμβάνετε *% προμήθεια.",
  比分竞猜: "Πρόβλεψη σκορ",
  豪礼相赠: "Μεγάλο δώρο",
  足球活动: "Ποδοσφαιρική δραστηριότητα",
  圣诞节活动: "Χριστουγεννιάτικη δραστηριότητα",
  "您参加了活动，临时锁定提现功能，还需*USDT流水就可以解除锁定。":
    "Συμμετείχατε σε μια δραστηριότητα. Η ανάληψη είναι προσωρινά μπλοκαρισμένη. Χρειάζεστε ακόμα * USDT όγκο για να ξεμπλοκάρετε.",
  剩余流水: "Υπόλοιπος όγκος",
  助力足球: "Υποστήριξη ποδοσφαίρου",
  佣金累计: "Συνολική προμήθεια",
  有效投注: "Έγκυρα στοιχήματα",
  今日: "Σήμερα",
  今日返水: "Cashback σήμερα",
  VIP返水: "Cashback VIP",
  返水记录: "Ιστορικό cashback",
  成员信息: "Πληροφορίες μέλους",
  基本信息: "Βασικές πληροφορίες",
  钱包余额: "Υπόλοιπο πορτοφολιού",
  投注信息: "Πληροφορίες στοιχήματος",
  返水: "Cashback",
  总下注: "Συνολικό στοίχημα",
  今日输赢: "Κέρδος/Ζημία σήμερα",
  下注动态: "Δραστηριότητα στοιχημάτων",
  返水奖励: "Ανταμοιβή cashback",
  分红金额: "Ποσό μερίσματος",
  返水支出: "Δαπάνη cashback",
  总返水: "Σύνολο cashback",
  流水总额: "Συνολικός όγκος",
  返水总额: "Σύνολο cashback",
  返水详情: "Λεπτομέρειες cashback",
  日流水: "Ημερήσιος όγκος",
  "平台根据你下级每日流水进行额外返水奖励,奖励每日新加坡时间00：00进行派发至赏金账户":
    "Η πλατφόρμα παρέχει επιπλέον cashback βάσει του ημερήσιου όγκου των downline σας. Πληρωμή καθημερινά στις 00:00 ώρα Σιγκαπούρης στον λογαριασμό ανταμοιβών.",
  "申请成功，等待审核": "Το αίτημα υποβλήθηκε επιτυχώς, αναμονή επαλήθευσης",
  "我出本金，盈利共分享": "Εγώ παρέχω το κεφάλαιο, το κέρδος μοιράζεται",
  最高分红: "Μέγιστο μέρισμα",
  投资大师比赛: "Διαγωνισμός Κύριος Επενδυτής",
  "我出本金，你盈利": "Εγώ παρέχω το κεφάλαιο, εσύ κερδίζεις",
  共分享: "Μοιραστείτε μαζί",
  最高分红可得: "Μέγιστο δυνατό μέρισμα",
  "新用户专属福利来袭，免费赠送$*，领取后即可投资平台任何项目，盈利后立即可提取。":
    "Αποκλειστικό μπόνους καλωσορίσματος: $* δωρεάν. Μετά τη λήψη, μπορείτε να επενδύσετε σε οποιοδήποτε έργο. Το κέρδος είναι άμεσα αναλήψιμο.",
  报名领取: "Εγγραφή και λήψη",
  审核驳回: "Η επαλήθευση απορρίφθηκε",
  驳回原因: "Λόγος απόρριψης",
  活动运行周期: "Περίοδος δραστηριότητας",
  "申请成功后起至*天内完成超额收益。":
    "Επιτύχετε υπερβάλλουσα απόδοση εντός * ημερών από την έγκριση.",
  分红比: "Αναλογία μερίσματος",
  "*日获得盈利后，可获得*%的收益额。":
    "Αφού επιτύχετε κέρδος την ημέρα *, λαμβάνετε *% του ποσού απόδοσης.",
  参与条件: "Προϋποθέσεις συμμετοχής",
  "俄罗斯、土耳其地区的用户，且未参与。":
    "Χρήστες από Ρωσία ή Τουρκία που δεν έχουν συμμετάσχει ακόμα.",
  计算项目: "Υπολογιζόμενα προϊόντα",
  "合约、体育、期权":
    "Συμβόλαια μελλοντικής εκπλήρωσης, Αθλητισμός, Δικαιώματα προαίρεσης",
  我的投资: "Οι επενδύσεις μου",
  参与天数: "Ημέρες συμμετοχής",
  累计下注: "Συνολικό στοίχημα",
  累计盈亏: "Συνολικό κέρδος/ζημία",
  预计可分红: "Αναμενόμενο μέρισμα",
  常见问题: "Συχνές ερωτήσεις (FAQ)",
  什么是平台出资: "Τι είναι η χρηματοδότηση πλατφόρμας;",
  "平台根据部分国家的用户，免费提供资金让用户去投项目。":
    "Η πλατφόρμα παρέχει δωρεάν κεφάλαια σε χρήστες από συγκεκριμένες χώρες για να επενδύσουν σε έργα.",
  怎么获取平台出资的福利:
    "Πώς μπορώ να λάβω το μπόνους χρηματοδότησης πλατφόρμας;",
  "您是指定国家的用户即可，点击上方报名按钮，当平台审核完成后将会把*USDT转入当前账户下的赏金账户，您可划转至其他账户下进行投资。":
    "Εάν είστε από μία από τις καθορισμένες χώρες, κάντε κλικ στο κουμπί εγγραφής. Μετά την έγκριση, * USDT θα μεταφερθούν στον λογαριασμό ανταμοιβών σας, τον οποίο μπορείτε να μεταφέρετε για να επενδύσετε.",
  什么是分红: "Τι είναι το μέρισμα;",
  "分红指在规定时间内，收益额到达100%后，可分得超额收益的50%。例如：领取100USDT资金，收益额度是120%。":
    "Μέρισμα: Εάν εντός του καθορισμένου χρόνου η απόδοση φτάσει το 100%, λαμβάνετε το 50% της υπερβάλλουσας απόδοσης. Π.χ.: Λαμβάνετε 100 USDT, επιτυγχάνετε 120% απόδοση, τότε το 20% είναι υπερβάλλον.",
  "如何取得分红？": "Πώς λαμβάνω το μέρισμα;",
  "活动周期每*天1次，活动结束后进行核算，满足活动要求后分红派发至赏金账户。若你未达到活动要求，系统将自动清除你的收益额和平台的出资。":
    "Ο κύκλος δραστηριότητας είναι κάθε * ημέρες. Μετά το τέλος, γίνεται εκκαθάριση. Εάν πληροίτε τις απαιτήσεις, το μέρισμα αποστέλλεται στον λογαριασμό ανταμοιβών. Εάν δεν πληροίτε, η απόδοσή σας και η χρηματοδότηση πλατφόρμας θα αφαιρεθούν.",
  "参与的账号需进行KYC认证，每个账户仅限一份福利。":
    "Οι λογαριασμοί που συμμετέχουν πρέπει να είναι επαληθευμένοι με KYC. Μόνο ένα μπόνους ανά λογαριασμό.",
  "参与账号的KYC需要指定的国家方可参与，其他地区无权限参与，请核对活动国家与您的国家是否一致。":
    "Το KYC για συμμετοχή ισχύει μόνο για καθορισμένες χώρες. Ελέγξτε αν η χώρα σας αντιστοιχεί στη χώρα δραστηριότητας.",
  "参与活动成功后，账户将临时锁定您的提现功能，当完成活动后即可解除您的提现功能。":
    "Μετά την επιτυχή συμμετοχή, η ανάληψη μπλοκάρεται προσωρινά μέχρι να ολοκληρωθεί η δραστηριότητα.",
  "请遵守平台活动规则，若发现作弊、利用系统漏洞进行获利，平台将会长期冻结您的账户下所有资金。":
    "Συμμορφωθείτε με τους κανόνες δραστηριότητας. Σε περίπτωση εξαπάτησης ή κατάχρησης σφαλμάτων συστήματος, όλα τα περιουσιακά στοιχεία στο λογαριασμό σας θα παγώσουν μόνιμα.",
  平台出资: "Χρηματοδότηση πλατφόρμας",
  平台出资收回: "Ανάκληση χρηματοδότησης πλατφόρμας",
  投资大师奖励: "Ανταμοιβή Κύριος Επενδυτής",
  请下载APP添加收款方式:
    "Κάντε λήψη της εφαρμογής για να προσθέσετε μια μέθοδο παραλαβής",
  请下载APP进行身份验证:
    "Κάντε λήψη της εφαρμογής για να πραγματοποιήσετε επαλήθευση ταυτότητας",
  请下载APP参与: "Κάντε λήψη της εφαρμογής για να συμμετάσχετε",
  技术指标: "Τεχνικοί δείκτες",
  主图: "Κύριο γράφημα",
  副图: "Δευτερεύον γράφημα",
  新注册人数: "Νέες εγγραφές",
  老用户存款人数: "Υφιστάμενοι χρήστες που καταθέτουν",
  存款人数: "Αριθμός καταθέσεων",
  取款人数: "Αριθμός αναλήψεων",
  投注人数: "Αριθμός στοιχημάτων",
  "除印度尼西亚、印度、孟加拉国，且未参与过的用户。":
    "Εξαιρουμένων χρηστών από Ινδονησία, Ινδία, Μπαγκλαντές που δεν έχουν συμμετάσχει ακόμα.",
  市场动态: "Δυναμική αγοράς",
  外汇合约: "Συμβόλαια μελλοντικής εκπλήρωσης Forex",
  盈亏比: "Αναλογία κέρδους/ζημίας",
  委托价: "Τιμή εντολής",
  可用余额: "Διαθέσιμο υπόλοιπο",
  持仓额: "Αξία θέσης",
  强平价: "Τιμή ρευστοποίησης",
  修改: "Τροποποίηση",
  修改价位: "Τροποποίηση τιμής",
  外汇: "Forex",
  外汇账户: "Λογαριασμός Forex",
  我的交易: "Οι συναλλαγές μου",
  未设置: "Δεν έχει οριστεί",
  超出最大可设数值: "Υπερβαίνει τη μέγιστη δυνατή τιμή",
  超出最小可设数值: "Υπολείπεται της ελάχιστης δυνατής τιμής",
  止盈超出最小可设数值:
    "Το όριο κέρδους υπολείπεται της ελάχιστης δυνατής τιμής",
  止损超出最大可设数值: "Η διακοπή ζημίας υπερβαίνει τη μέγιστη δυνατή τιμή",
  止盈超出最大可设数值: "Το όριο κέρδους υπερβαίνει τη μέγιστη δυνατή τιμή",
  止损超出最小可设数值:
    "Η διακοπή ζημίας υπολείπεται της ελάχιστης δυνατής τιμής",
  挖矿: "Εξόρυξη",
  交易账户: "Λογαριασμός συναλλαγών",
  买涨: "Αγορά (Long)",
  买跌: "Πώληση (Short)",
  请输入正确的银行卡信息: "Εισάγετε σωστά στοιχεία τραπεζικής κάρτας",
  联系在线客服: "Επικοινωνήστε με την άμεση υποστήριξη",
  法币交易请联系在线客服: "Επικοινωνήστε με την υποστήριξη για συναλλαγές fiat",
  提交订单: "Υποβολή παραγγελίας",
  "支付过程如有疑问,请联系在线客服":
    "Επικοινωνήστε με την υποστήριξη για απορίες σχετικά με τη διαδικασία πληρωμής",
  彩金赠送: "Χορήγηση μπόνους",
  在线客服: "Άμεση υποστήριξη",
  最少投资: "Ελάχιστη επένδυση",
  "提交时间:": "Ώρα υποβολής:",
  提现拒绝: "Ανάληψη απορρίφθηκε",
  认证拒绝: "Επαλήθευση απορρίφθηκε",
  认证通过: "Επαλήθευση εγκρίθηκε",
  请输入正确的交易额度: "Εισάγετε έγκυρο ποσό συναλλαγής",
  最大下注金额: "Μέγιστο στοίχημα",
  手机号: "Αριθμός κινητού",
  邮箱注册: "Εγγραφή με email",
  手机号注册: "Εγγραφή με κινητό",
  查询: "Αναζήτηση",
  手机号登录: "Σύνδεση με κινητό",
  邮箱登录: "Σύνδεση με email",
  请输入数量: "Εισάγετε ποσότητα",
  可用数量: "Διαθέσιμη ποσότητα",
  钱包登录: "Σύνδεση με πορτοφόλι",
  请输入正确的邀请码: "Εισάγετε έγκυρο κωδικό πρόσκλησης",
  "请输入邀请码(必填)": "Εισάγετε κωδικό πρόσκλησης (υποχρεωτικό)",
  输入正确的金额: "Εισάγετε έγκυρο ποσό",
  法币充值: "Κατάθεση fiat",
  卢比充值: "Κατάθεση Ρουπίας Ινδίας",
  请输入法币: "Εισάγετε ποσό fiat",
  请输入IFSC: "Εισάγετε κωδικό IFSC",
  "银行编码(选填)": "Κωδικός τράπεζας (προαιρετικό)",
  请输入银行编码: "Εισάγετε κωδικό τράπεζας",
  请输入大于8位数的密码: "Εισάγετε κωδικό με περισσότερους από 8 χαρακτήρες",
  添加成功: "Επιτυχής προσθήκη",
  "60秒": "60 δευτερόλεπτα",
  "180秒": "180 δευτερόλεπτα",
  "300秒": "300 δευτερόλεπτα",
  "2次密码不一致": "Οι κωδικοί δεν συμπίπτουν",
  输入提币数量: "Εισάγετε ποσότητα ανάληψης",
  图片格式不正确: "Μη έγκυρη μορφή εικόνας",
  图片大于20M: "Η εικόνα είναι μεγαλύτερη από 20 MB",
  请设置委托价格: "Ορίστε τιμή εντολής",
  输入资金密码: "Εισάγετε τον κωδικό περιουσιακών στοιχείων",
  验证码错误: "Λανθασμένος κωδικός επαλήθευσης",
  充值拒绝: "Κατάθεση απορρίφθηκε",
  请输入SSN: "Εισάγετε ΑΜΚΑ (SSN)",
  结算完成: "Ο διακανονισμός ολοκληρώθηκε",
  继续下单: "Συνέχεια παραγγελίας",
  限价: "Εντολή ορίου",
  买入价格: "Τιμή αγοράς",
  买入量: "Ποσότητα αγοράς",
  卖出价格: "Τιμή πώλησης",
  卖出量: "Ποσότητα πώλησης",
  买入: "Αγορά",
  卖出: "Πώληση",
  订单创建成功: "Η παραγγελία δημιουργήθηκε επιτυχώς",
  币币买入支出: "Δαπάνη αγοράς spot",
  币币买入支出退还: "Επιστροφή δαπάνης αγοράς spot",
  币币买入获得: "Λήψη από αγορά spot",
  币币卖出支出: "Δαπάνη πώλησης spot",
  币币卖出支出退还: "Επιστροφή δαπάνης πώλησης spot",
  币币卖出获得: "Λήψη από πώληση spot",
  币币交易手续费: "Χρέωση συναλλαγής spot",
  请输入限价: "Εισάγετε τιμή ορίου",
  成交: "Εκτελέστηκε",
  等待成交: "Αναμονή εκτέλεσης",
  交易完成: "Η συναλλαγή ολοκληρώθηκε",
  被取消: "Ακυρώθηκε",
  交易时间: "Ώρα συναλλαγής",
  法币交易: "Συναλλαγή fiat",
  法币出售: "Πώληση fiat",

  两次密码不一致: "Οι κωδικοί δεν συμπίπτουν",
  再次输入账户密码: "Εισάγετε ξανά τον κωδικό λογαριασμού",

  美国: "Ηνωμένες Πολιτείες",
  韩国: "Νότια Κορέα",
  阿尔巴尼亚: "Αλβανία",
  津巴布韦: "Ζιμπάμπουε",
  赞比亚: "Ζάμπια",
  也门: "Υεμένη",
  美属维尔京群岛: "Αμερικανικές Παρθένοι Νήσοι",
  英属处女群岛: "Βρετανικές Παρθένοι Νήσοι",
  越南: "Βιετνάμ",
  委内瑞拉: "Βενεζουέλα",
  瓦努阿图: "Βανουάτου",
  乌兹别克斯坦: "Ουζμπεκιστάν",
  乌拉圭: "Ουρουγουάη",
  英国: "Ηνωμένο Βασίλειο",
  阿拉伯联合酋长国: "Ηνωμένα Αραβικά Εμιράτα",
  乌克兰: "Ουκρανία",
  乌干达: "Ουγκάντα",
  特克斯和凯科斯群岛: "Νήσοι Τερκς και Κάικος",
  土库曼斯坦: "Τουρκμενιστάν",
  土耳其: "Τουρκία",
  突尼斯: "Τυνησία",
  特立尼达和多巴哥: "Τρινιντάντ και Τομπάγκο",
  汤加: "Τόνγκα",
  多哥: "Τόγκο",
  东帝汶: "Ανατολικό Τιμόρ",
  泰国: "Ταϊλάνδη",
  坦桑尼亚: "Τανζανία",
  塔吉克斯坦: "Τατζικιστάν",
  中国台湾: "Ταϊβάν",
  叙利亚: "Συρία",
  瑞士: "Ελβετία",
  瑞典: "Σουηδία",
  斯威士兰: "Εσουατίνι",
  苏里南: "Σουρινάμ",
  苏丹: "Σουδάν",
  斯里兰卡: "Σρι Λάνκα",
  西班牙: "Ισπανία",
  南非: "Νότια Αφρική",
  索马里: "Σομαλία",
  所罗门群岛: "Νήσοι Σολομώντα",
  斯洛文尼亚: "Σλοβενία",
  斯洛伐克: "Σλοβακία",
  "圣马丁岛（荷兰部分）": "Άγιος Μαρτίνος (ολλανδικό τμήμα)",
  新加坡: "Σιγκαπούρη",
  塞拉利昂: "Σιέρα Λεόνε",
  塞舌尔: "Σεϋχέλλες",
  塞尔维亚: "Σερβία",
  塞内加尔: "Σενεγάλη",
  沙特阿拉伯: "Σαουδική Αραβία",
  圣多美和普林西比: "Σάο Τομέ και Πρίνσιπε",
  圣马力诺: "Άγιος Μαρίνος",
  萨摩亚: "Σαμόα",
  圣克里斯托弗和尼维斯: "Άγιος Χριστόφορος και Νέβις",
  圣文森特和格林纳丁斯: "Άγιος Βικέντιος και Γρεναδίνες",
  圣彼埃尔和密克隆岛: "Σαιν Πιερ και Μικελόν",
  圣露西亚: "Αγία Λουκία",
  圣基茨和尼维斯: "Άγιος Χριστόφορος και Νέβις",
  卢旺达: "Ρουάντα",
  俄罗斯: "Ρωσία",
  罗马尼亚: "Ρουμανία",
  留尼汪: "Ρεϋνιόν",
  刚果共和国: "Δημοκρατία του Κονγκό",
  卡塔尔: "Κατάρ",
  波多黎各: "Πουέρτο Ρίκο",
  葡萄牙: "Πορτογαλία",
  波兰: "Πολωνία",
  菲律宾: "Φιλιππίνες",
  秘鲁: "Περού",
  巴拉圭: "Παραγουάη",
  巴布亚新几内亚: "Παπούα Νέα Γουινέα",
  巴拿马: "Παναμάς",
  巴勒斯坦: "Παλαιστίνη",
  帕劳: "Παλάου",
  巴基斯坦: "Πακιστάν",
  阿曼: "Ομάν",
  挪威: "Νορβηγία",
  尼日利亚: "Νιγηρία",
  尼日尔: "Νίγηρας",
  尼加拉瓜: "Νικαράγουα",
  新西兰: "Νέα Ζηλανδία",
  新喀里多尼亚: "Νέα Καληδονία",
  荷属安德列斯群岛: "Ολλανδικές Αντίλλες",
  荷兰: "Κάτω Χώρες",
  尼泊尔: "Νεπάλ",
  纳米比亚: "Ναμίμπια",
  缅甸: "Μιανμάρ",
  莫桑比克: "Μοζαμβίκη",
  摩洛哥: "Μαρόκο",
  蒙特塞拉特岛: "Μοντσερράτ",
  黑山: "Μαυροβούνιο",
  蒙古: "Μογγολία",
  摩纳哥: "Μονακό",
  摩尔多瓦: "Μολδαβία",
  墨西哥: "Μεξικό",
  马约特: "Μαγιότ",
  毛里求斯: "Μαυρίκιος",
  毛里塔尼亚: "Μαυριτανία",
  马里亚纳群岛: "Νήσοι Μαριάνας",
  马提尼克: "Μαρτινίκα",
  马耳他: "Μάλτα",
  马里: "Μάλι",
  马尔代夫: "Μαλδίβες",
  马来西亚: "Μαλαισία",
  马拉维: "Μαλάουι",
  马达加斯加: "Μαδαγασκάρη",
  马其顿: "Βόρεια Μακεδονία",
  中国澳门: "Μακάο",
  卢森堡: "Λουξεμβούργο",
  立陶宛: "Λιθουανία",
  列支敦士登: "Λίχτενσταϊν",
  利比亚: "Λιβύη",
  利比里亚: "Λιβερία",
  莱索托: "Λεσότο",
  黎巴嫩: "Λίβανος",
  拉脱维亚: "Λετονία",
  老挝: "Λάος",
  吉尔吉斯斯坦: "Κιργιστάν",
  科威特: "Κουβέιτ",
  基里巴斯: "Κιριμπάτι",
  肯尼亚: "Κένυα",
  哈萨克斯坦: "Καζακστάν",
  约旦: "Ιορδανία",
  日本: "Ιαπωνία",
  牙买加: "Τζαμάικα",
  象牙海岸: "Ακτή Ελεφαντοστού",
  意大利: "Ιταλία",
  以色列: "Ισραήλ",
  爱尔兰: "Ιρλανδία",
  伊拉克: "Ιράκ",
  伊朗: "Ιράν",
  印度尼西亚: "Ινδονησία",
  印度: "Ινδία",
  冰岛: "Ισλανδία",
  匈牙利: "Ουγγαρία",
  中国香港: "Χονγκ Κονγκ",
  洪都拉斯: "Ονδούρα",
  海地: "Αϊτή",
  圭亚那: "Γουιάνα",
  几内亚比绍共和国: "Γουινέα-Μπισσάου",
  几内亚: "Γουινέα",
  危地马拉: "Γουατεμάλα",
  关岛: "Γκουάμ",
  瓜德罗普岛: "Γουαδελούπη",
  格林纳达: "Γρενάδα",
  格陵兰岛: "Γροιλανδία",
  希腊: "Ελλάδα",
  直布罗陀: "Γιβραλτάρ",
  加纳: "Γκάνα",
  德国: "Γερμανία",
  格鲁吉亚: "Γεωργία",
  冈比亚: "Γκάμπια",
  加蓬: "Γκαμπόν",
  法属波利尼西亚: "Γαλλική Πολυνησία",
  法属圭亚那: "Γαλλική Γουιάνα",
  法国: "Γαλλία",
  芬兰: "Φινλανδία",
  斐济: "Φίτζι",
  法罗群岛: "Νήσοι Φερόες",
  埃塞俄比亚: "Αιθιοπία",
  爱沙尼亚: "Εσθονία",
  厄立特里亚: "Ερυθραία",
  赤道几内亚: "Ισημερινή Γουινέα",
  萨尔瓦多: "Ελ Σαλβαδόρ",
  埃及: "Αίγυπτος",
  厄瓜多尔: "Εκουαδόρ",
  多米尼加共和国: "Δομινικανή Δημοκρατία",
  多米尼加: "Δομινίκα",
  吉布提: "Τζιμπουτί",
  丹麦: "Δανία",
  捷克: "Τσεχία",
  塞浦路斯: "Κύπρος",
  库拉索: "Κουρασάο",
  古巴: "Κούβα",
  克罗地亚: "Κροατία",
  哥斯达黎加: "Κόστα Ρίκα",
  科特迪瓦: "Ακτή Ελεφαντοστού",
  库克群岛: "Νήσοι Κουκ",
  科摩罗: "Κομόρες",
  哥伦比亚: "Κολομβία",
  智利: "Χιλή",
  乍得: "Τσαντ",
  中非共和国: "Κεντροαφρικανική Δημοκρατία",
  佛得角: "Πράσινο Ακρωτήριο",
  开曼群岛: "Νήσοι Κέιμαν",
  开普: "Κέιπ",
  加拿大: "Καναδάς",
  喀麦隆: "Καμερούν",
  柬埔寨: "Καμπότζη",
  布隆迪: "Μπουρούντι",
  布基纳法索: "Μπουρκίνα Φάσο",
  保加利亚: "Βουλγαρία",
  文莱: "Μπρουνέι",
  巴西: "Βραζιλία",
  博茨瓦纳: "Μποτσουάνα",
  波斯尼亚和黑塞哥维那: "Βοσνία και Ερζεγοβίνη",
  玻利维亚: "Βολιβία",
  不丹: "Μπουτάν",
  百慕大群岛: "Βερμούδες",
  贝宁: "Μπενίν",
  伯利兹: "Μπελίζ",
  比利时: "Βέλγιο",
  白俄罗斯: "Λευκορωσία",
  巴巴多斯: "Μπαρμπάντος",
  孟加拉国: "Μπαγκλαντές",
  巴林: "Μπαχρέιν",
  巴哈马: "Μπαχάμες",
  阿塞拜疆: "Αζερμπαϊτζάν",
  奥地利: "Αυστρία",
  澳大利亚: "Αυστραλία",
  阿鲁巴: "Αρούμπα",
  亚美尼亚: "Αρμενία",
  阿根廷: "Αργεντινή",
  安提瓜和巴布达: "Αντίγκουα και Μπαρμπούντα",
  安圭拉: "Ανγκουίλα",
  安哥拉: "Ανγκόλα",
  安道尔: "Ανδόρρα",
  美属萨摩亚: "Αμερικανική Σαμόα",
  阿尔及利亚: "Αλγερία",
  中国: "Κίνα",
  余额不足: "Ανεπαρκές υπόλοιπο",
  最低购买: "Ελάχιστη αγορά",
  最高购买: "Μέγιστη αγορά",
  下单成功: "Η παραγγελία υποβλήθηκε επιτυχώς",
  平仓成功: "Η θέση έκλεισε επιτυχώς",
  请输入正确的平仓数量: "Εισάγετε έγκυρη ποσότητα κλεισίματος",
  加仓成功: "Η αύξηση θέσης ήταν επιτυχής",
  请输入正确的加仓金额: "Εισάγετε έγκυρο ποσό για αύξηση θέσης",
  收藏成功: "Προστέθηκε στα αγαπημένα",
  取消收藏成功: "Αφαιρέθηκε από τα αγαπημένα",
  加密币永续: "Διαιωνιζόμενο κρυπτονομίσματος",
  外汇永续: "Διαιωνιζόμενο Forex",
  期权账户: "Λογαριασμός δικαιωμάτων προαίρεσης",
  快捷卖币: "Γρήγορη πώληση κρυπτονομίσματος",

  托管资金: "Διαχειριζόμενα κεφάλαια",
  托管中: "Υπό διαχείριση",
  预计日收益: "Εκτιμώμενη ημερήσια απόδοση",
  累计收益: "Συνολική απόδοση",
  周期: "Διάρκεια",
  日收益: "Ημερήσια απόδοση",
  限额: "Όριο",
  立即托管: "Άμεση έναρξη διαχείρισης",
  "已鎖定 請聯繫客服": "Έχει κλειδωθεί. Επικοινωνήστε με την υποστήριξη.",
  产品列表: "Λίστα προϊόντων",
  规则: "Κανόνες",
  创建订单: "Δημιουργία παραγγελίας",
  产品名称: "Όνομα προϊόντος",
  托管周期: "Περίοδος διαχείρισης",
  等级限制: "Περιορισμός επιπέδου",
  托管金额: "Ποσό υπό διαχείριση",
  限额: "Όριο",
  余额: "Υπόλοιπο",
  购买日: "Ημερομηνία αγοράς",
  起息日: "Έναρξη υπολογισμού τόκων",
  派息时间: "Ώρα πληρωμής τόκων",
  每天: "Καθημερινά",
  计息结束日: "Ημερομηνία λήξης τόκων",
  每日收益: "Ημερήσια απόδοση",
  预计收益: "Εκτιμώμενη απόδοση",
  "收益将自动发送至您的余额账户;":
    "Η απόδοση θα αποστέλλεται αυτόματα στο υπόλοιπο του λογαριασμού σας·",
  "您的资金没有任何风险;": "Τα κεφάλαιά σας δεν διατρέχουν κανέναν κίνδυνο·",
  "365*24小时不断地工作;": "Λειτουργεί 24/7, 365 ημέρες το χρόνο·",
  托管中: "Υπό διαχείριση",
  结束: "Ολοκληρώθηκε",
  今日收益: "Απόδοση σήμερα",
  剩余周期: "Υπόλοιπη διάρκεια",
  进行中: "Ενεργό",
  已发放: "Καταβλήθηκε",
  信誉分: "Βαθμολογία φήμης",

  复制成功: "Αντιγραφή επιτυχής",
  VIP权益: "Προνόμια VIP",
  旧密码: "Παλιός κωδικός πρόσβασης",
  请输入旧密码: "Εισάγετε τον παλιό κωδικό πρόσβασης",
  "忘记旧密码请联系客服重置。":
    "Εάν ξεχάσατε τον παλιό σας κωδικό πρόσβασης, παρακαλούμε επικοινωνήστε με την εξυπηρέτηση πελατών για να τον επαναφέρετε.",
  去升级: "Αναβάθμιση",
  描述: "Περιγραφή",
  实际存款金额: "Πραγματικό ποσό κατάθεσης",
  升级礼金: "Μπόνους αναβάθμισης",
  隔夜利息: "Τόκοι διανυκτέρευσης (swap)",
  自动结算: "Αυτόματος διακανονισμός",
  等级规则: "Κανόνες επιπέδων",
  "WEB3.0币持有数据收益": "Απόδοση δεδομένων κατοχής νομισμάτων WEB3.0",
  总生产: "Συνολική παραγωγή",
  有效节点: "Ενεργοί κόμβοι",
  参与人: "Συμμετέχοντες",
  用户收益: "Απόδοση χρήστη",
  "流动性WEB3.0输出": "Έξοδος ρευστότητας WEB3.0",
  总资产: "Σύνολο ενεργητικού",

  ETHAI持有数据收益: "Απόδοση δεδομένων κατοχής ETHAI",
  AI量化流动性: "AI ποσοτική ρευστότητα",
  现货买入手续费: "Προμήθεια αγοράς spot",
  现货支出: "Δαπάνη spot",
  现货资金费率: "Επιτόκιο χρηματοδότησης spot",
  现货卖出手续费: "Προμήθεια πώλησης spot",
  现货收入: "Έσοδο spot",
  外汇合约支出: "Δαπάνη συμβολαίου συναλλάγματος",
  外汇合约买入手续费: "Προμήθεια αγοράς συμβολαίου συναλλάγματος",
  外汇合约资金费率: "Επιτόκιο χρηματοδότησης συμβολαίου συναλλάγματος",
  外汇合约卖出手续费: "Προμήθεια πώλησης συμβολαίου συναλλάγματος",
  外汇合约收入: "Έσοδο από συμβόλαιο συναλλάγματος",
  理财购买: "Αγορά επενδυτικού προϊόντος",
  VIP理财日收益: "Ημερήσια απόδοση VIP επενδυτικού προϊόντος",
  VIP理财隔夜利息: "Διανυκτέρευση τόκος VIP επενδυτικού προϊόντος",
  VIP本金返还: "Επιστροφή κεφαλαίου VIP",
  VIP彩金发放: "Διανομή μπόνους VIP",
  VIP彩金抵扣: "Έκπτωση μπόνους VIP",
  隔夜利息: "Διανυκτέρευση τόκος",
  设置资产密码: "Ορισμός κωδικού πρόσβασης περιουσιακών στοιχείων",

  锁仓挖矿: "Κλειδωμένη εξόρυξη",
  一站式理财服务: "Ολοκληρωμένες χρηματοοικονομικές υπηρεσίες",
  产品: "Προϊόντα",
  客服中心: "Κέντρο εξυπηρέτησης πελατών",
  贷款: "Δάνεια",
  挖矿赚不停: "Συνεχές κέρδος από εξόρυξη",
  "锁仓挖矿是通过将USDT (USD:1USDT=1USD) 托管给平台超算力矿机，在平台矿池中进行挖矿收益。":
    "Η κλειδωμένη εξόρυξη είναι η διαδικασία κατάθεσης USDT (USD:1USDT=1USD) σε μηχανές εξόρυξης υψηλής ισχύος της πλατφόρμας για απόδοση στο mining pool της πλατφόρμας.",
  产品优势: "Πλεονεκτήματα προϊόντος",
  随存随取: "Κατάθεση και ανάληψη οποιαδήποτε στιγμή",
  锁仓周期: "Περίοδος κλειδώματος",
  每日下发: "Ημερήσιες αποδόσεις",
  随机空投: "Τυχαίο airdrop",
  "100%资金安全保障": "100% εγγύηση ασφάλειας κεφαλαίων",
  "100%节假日收益不间断": "100% συνεχής απόδοση ακόμη και στις αργίες",
  成功锁仓后当天产出: "Απόδοση από την ίδια ημέρα μετά το επιτυχημένο κλείδωμα",
  关于违约金: "Σχετικά με την ποινή",
  "若您希望转出未到期的本金,则会产生违约金,违约金=违约结算比例*剩余天数*锁仓金额.":
    "Εάν αποσύρετε το κεφάλαιο πριν τη λήξη, επιβάλλεται ποινή. Ποινή = ποσοστό ποινής × υπολειπόμενες ημέρες × κλειδωμένο ποσό.",
  "举例:此锁仓挖矿的违约结算比例为5%,剩余3天到期,锁仓金额为10000U《USDT/USD》,则违约金=5%*3*10000=1500U,实际退回本金为15000U-1500U":
    "Παράδειγμα: ποσοστό ποινής 5%, απομένουν 3 ημέρες, κλειδωμένο ποσό 10000U (USDT/USD). Ποινή = 5%×3×10000=1500U, το καθαρό επιστρεφόμενο ποσό είναι 15000U-1500U.",
  收益计算: "Υπολογισμός απόδοσης",
  "平台有多种锁仓挖矿理财产品供使用者选择,收益计算如下,举例:":
    "Η πλατφόρμα προσφέρει διάφορα επενδυτικά προϊόντα κλειδωμένης εξόρυξης. Ο υπολογισμός απόδοσης είναι ο εξής, για παράδειγμα:",
  "会员在平台锁仓10000U(USDT,USD),如选择了周期为7天,日产出为锁仓金额的0.7%~1.8%的理财产品,则每天产出如下":
    "Εάν ο χρήστης κλειδώσει 10000U (USDT, USD) και επιλέξει προϊόν 7 ημερών με ημερήσια απόδοση 0,7%~1,8%, η ημερήσια απόδοση είναι:",
  "最低:10000Ux0.7%=70U;": "Ελάχιστο: 10000U×0,7%=70U;",
  "最高:10000Ux1.8%=180U;": "Μέγιστο: 10000U×1,8%=180U;",
  "即7天后可获得490U~1260U的收益,收益每日下发,锁仓本金到期后,自动转入您的资金账户.":
    "Μετά από 7 ημέρες, το κέρδος είναι 490U~1260U. Οι αποδόσεις καταβάλλονται καθημερινά και το κεφάλαιο μεταφέρεται αυτόματα στον λογαριασμό σας στη λήξη.",
  正在托管的资金: "Κεφάλαια υπό διαχείριση",
  签到: "Είσοδος",
  锁仓订单: "Κλειδωμένες εντολές",
  预计今日收益: "Εκτιμώμενη σημερινή απόδοση",
  累计收益: "Συνολική απόδοση",
  托管中的订单: "Εντολές υπό διαχείριση",
  单笔最少: "Ελάχιστο ποσό ανά εντολή",
  单笔最多: "Μέγιστο ποσό ανά εντολή",
  日收益率: "Ημερήσια απόδοση",
  说明: "Περιγραφή",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出<br>3.当天的收益会统一在次日GMT+8时间00:00-00:10内派发.":
    "1. Τα δεδομένα βασίζονται σε ώρα GMT+8<br>2. Η ημερήσια απόδοση υπολογίζεται από όλες τις εκκαθαρισμένες εντολές 00:00-23:59 GMT+8<br>3. Οι αποδόσεις καταβάλλονται την επόμενη ημέρα 00:00-00:10 GMT+8.",
  知道了: "Εντάξει",
  锁仓: "Κλείδωμα",
  派息时间: "Ώρα πληρωμής",
  每日: "Καθημερινά",
  托管资金: "Κεφάλαια διαχείρισης",
  到期返回: "Επιστροφή στη λήξη",
  提前赎回: "Πρόωρη ανάληψη",
  预计收益: "Εκτιμώμενη απόδοση",
  认购: "Εγγραφή",
  热门: "Δημοφιλή",
  数字货币: "Κρυπτονομίσματα",
  贵金属: "Πολύτιμα μέταλλα",
  大宗商品: "Εμπορεύματα",
  持仓明细: "Λεπτομέρειες θέσης",
  历史明细: "Ιστορικό",
  当前价: "Τρέχουσα τιμή",
  "↑买涨": "↑ Αγορά ανόδου",
  "↓买跌": "↓ Αγορά πτώσης",
  显示全部: "Εμφάνιση όλων",
  买入金额: "Ποσό αγοράς",
  方向: "Κατεύθυνση",
  收益: "Κέρδος",
  预期收益: "Αναμενόμενο κέρδος",
  估用保证金: "Εκτιμώμενο περιθώριο",
  确认下单: "Επιβεβαίωση εντολής",
  锁定: "Κλειδωμένο",
  账户总资产: "Συνολικά περιουσιακά στοιχεία",
  明细: "Λεπτομέρειες",
  今日收益: "Σημερινό κέρδος",
  仓位保证金: "Περιθώριο θέσης",
  持有仓位: "Ανοιχτές θέσεις",
  "锁定金额=所有锁仓挖矿中未完成订单的金额总和":
    "Κλειδωμένο ποσό = άθροισμα όλων των μη ολοκληρωμένων εντολών κλειδωμένης εξόρυξης",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出":
    "1. Τα δεδομένα βασίζονται σε GMT+8<br>2. Η ημερήσια απόδοση υπολογίζεται από εκκαθαρισμένες εντολές",
  充值方式: "Μέθοδος κατάθεσης",
  银行汇款: "Τραπεζικό έμβασμα",
  "银行汇款请联系客服进行操作!":
    "Επικοινωνήστε με την υποστήριξη για τραπεζικό έμβασμα!",
  提款方式: "Μέθοδος ανάληψης",
  "银行提款请联系客服进行操作!":
    "Επικοινωνήστε με την υποστήριξη για τραπεζική ανάληψη!",
  资金明细: "Λεπτομέρειες κεφαλαίων",
  提现记录: "Ιστορικό αναλήψεων",
  拒绝: "Απορρίφθηκε",
  通过: "Εγκρίθηκε",
  拒绝原因: "Λόγος απόρριψης",

  消息公告: "Ανακοινώσεις",
  订单: "Παραγγελίες",
  个人中心: "Προσωπικό κέντρο",
  "未到期赎回需支付一定的违约金!":
    "Σε πρόωρη εξαγορά απαιτείται η πληρωμή ποινής.",

  请输入区号: "Παρακαλώ εισαγάγετε τον κωδικό περιοχής",
  "请选择国家/地区": "Παρακαλώ επιλέξτε χώρα/περιοχή",

  今日开盘: "Άνοιγμα σήμερα",
  昨日收盘: "Κλείσιμο χθες",

  实名认证即送: "Λάβετε το αμέσως μετά την επαλήθευση ταυτότητας",
  立即认证: "Επαλήθευση τώρα",
  新用户礼包: "Πακέτο δώρου νέου χρήστη",
  完成新人任务领取: "Ολοκληρώστε τις εργασίες νέου χρήστη για να το λάβετε",
  认证: "Επαλήθευση",
  时间周期: "Χρονική περίοδος",
  支付金额: "Ποσό πληρωμής",
  已平仓: "Έχει κλείσει",
  "MGBX 新用户欢迎礼包：每位用户最多可获得":
    "Πακέτο καλωσορίσματος νέων χρηστών MGBX: κάθε χρήστης μπορεί να λάβει έως",
  我已经阅读并同意: "Έχω διαβάσει και συμφωνώ με",
  隐私政策: "Πολιτική απορρήτου",

  放弃奖励离开: "Εγκατάλειψη ανταμοιβής και έξοδος",
  继续注册: "Συνέχεια εγγραφής",
  分钟: "Λεπτά",

  "请先勾选隐私政策!": "Παρακαλούμε ελέγξτε πρώτα την Πολιτική Απορρήτου!",

  添加其他到自选: "Προσθήκη άλλων στη λίστα παρακολούθησης",

  充值最高可得: "Κάνε ανανέωση και λάβε έως και 30.000 $.",

  请输入格式正确的手机号:
    "Παρακαλώ εισαγάγετε έναν έγκυρο αριθμό κινητού τηλεφώνου.",
  收起: "Collapse",
  上传截图: "Upload screenshot",
  "*充值成功后必须上传充值截图，否则将视为无效存款。": "*After a successful recharge, you must upload the recharge screenshot; otherwise the deposit will be invalid.",
};
// 希腊



// WEBPACK FOOTER //
// ./src/lang/xl.js